(function(){
"use strict";
var MC_API   = "https://script.google.com/macros/s/AKfycbx4cDDEvk8YNl8_ObUtTyXL44ASWsO24yYbN4RUmPpSekq3eGhyuZGRQ4ieg8_DBoUq/exec";
var MC_TOKEN = "mc_cc6f126b6aaf46bfa553068c22727813";
var DROPSHIP = /camiseta|moletom|moleton|canguru|\bkit\b|bundle/i;
var BUNDLE = /\bkit\b|\bkits\b|bundle|combo/i;
/* tokens de tamanho reconhecidos — um segmento só vira "tamanho" se for EXATAMENTE um destes.
   Assim "M Crew" (M é o nome, não o tamanho) não é confundido com tamanho M. */
var SIZE_TOKENS={PP:1,XPP:1,P:1,M:1,G:1,GG:1,XG:1,XGG:1,XXG:1,U:1,UNICO:1};
function normSize(t){ return String(t||'').toUpperCase().replace('ÚNICO','UNICO').trim(); }
function isPureSize(t){ t=normSize(t); return SIZE_TOKENS[t]===1 || /^\d{1,3}$/.test(t); }
/* separa o título da variação em segmentos (Shopify usa " / " entre as opções) */
function vSegs(s){ return String(s||'').split(/[\/·]/).map(function(x){return x.trim();}).filter(Boolean); }
/* extrai o tamanho de uma variação (P/M/G/GG/…); usado pra unificar bundles.
   Procura um segmento que seja tamanho PURO (do fim pro começo — o tamanho costuma ser o último). */
function sizeKey(v){
  var s=String((v&&(v.tamanho||v.variant_title))||"");
  var parts=vSegs(s);
  for(var i=parts.length-1;i>=0;i--){ if(isPureSize(parts[i])) return normSize(parts[i]); }
  return s.trim()?normSize(s):"—"; // sem segmento de tamanho → usa o texto todo como chave
}
/* nome do modelo (estampa/camiseta) da variante = título sem o segmento de tamanho.
   Ex.: "M Crew / M" → "M Crew" (remove só o último "M", o tamanho). */
function modelKey(v){
  var s=String((v&&(v.variant_title||v.tamanho))||'').trim();
  if(!s) return '';
  var parts=vSegs(s);
  if(parts.length>1){
    for(var i=parts.length-1;i>=0;i--){ if(isPureSize(parts[i])){ parts.splice(i,1); break; } }
    return parts.join(' / ').trim();
  }
  return isPureSize(s) ? '' : s; // segmento único: tamanho puro → sem modelo; senão o texto é o modelo
}
/* rótulo da variante no gráfico de tamanhos: se houver um segmento de tamanho PURO
   (P/M/G/GG/…), mostra só ele — evita exibir "Crew / M" (nome da estampa + tamanho)
   como se fosse um tamanho inexistente. Senão, usa o texto como está. */
function sizeLabel(v){
  var raw=String((v&&(v.tamanho||v.variant_title||v.cor))||"").trim();
  if(!raw) return "—";
  var parts=vSegs(raw);
  if(parts.length>1){ for(var i=parts.length-1;i>=0;i--){ if(isPureSize(parts[i])) return normSize(parts[i]); } }
  else if(isPureSize(raw)) return normSize(raw);
  return raw;
}
/* dataset do gráfico de variantes */
function buildVdata(src){
  var totU=(src||[]).reduce(function(s,v){return s+Number(v.unidades||v.unidades_vendidas||0);},0)||1;
  return (src||[]).map(function(v){
    var un=Number(v.unidades||v.unidades_vendidas||0);
    return { label:sizeLabel(v), receita:Number(v.receita||v.receita_gerada||0),
      unidades:un, share:un/totU, cancelados:Number(v.cancelados||0), devolucoes:Number(v.devolucoes||0) };
  });
}
/* ordem FIXA dos tamanhos (PP P M G GG XG...), com todos os tamanhos do catálogo mesmo sem venda */
var SIZE_ORDER=['PP','P','M','G','GG','XG','XGG','XXG','U','UNICO'];
function sizeIdx(l){ var k=sizeKey({tamanho:l}); var i=SIZE_ORDER.indexOf(k); return i<0?100:i; }
function padSizes(vd,catSizes){
  var have={}; vd.forEach(function(v){ have[sizeKey({tamanho:v.label})]=1; });
  (catSizes||[]).forEach(function(sz){
    var k=sizeKey({tamanho:sz});
    if(k&&k!=='—'&&!have[k]){ have[k]=1; vd.push({label:k,receita:0,unidades:0,share:0,cancelados:0,devolucoes:0}); }
  });
  vd.sort(function(a,b){ var d=sizeIdx(a.label)-sizeIdx(b.label); return d!==0?d:String(a.label).localeCompare(String(b.label)); });
  return vd.slice(0,12);
}
function vcolHtml(v){
  return '<div class="pad-vcol" data-receita="'+v.receita+'" data-unidades="'+v.unidades+'" data-share="'+v.share+'" data-cancelados="'+v.cancelados+'" data-devolucoes="'+v.devolucoes+'" data-label="'+esc(v.label)+'" title="'+esc(v.label)+'">'
    +'<span class="pad-vcol-val"></span>'
    +'<div class="pad-vcol-track"><div class="pad-vcol-fill"></div><div class="pad-vcol-fill f2"></div></div>'
    +'<span class="pad-vcol-lbl">'+esc(v.label.slice(0,6))+'</span>'
    +'<span class="pad-vcol-un">'+NUM(v.unidades)+'un</span></div>';
}
/* agrupa variações pelo tamanho e soma as métricas numéricas (bundles/kits) */
function unifyBySize(list){
  var map={}, order=[];
  (list||[]).forEach(function(v){
    var k=sizeKey(v);
    if(!map[k]){ map[k]=Object.assign({},v); map[k].variant_title=k; map[k].tamanho=k;
      map[k].receita_gerada=0; map[k].unidades_vendidas=0; map[k].custo_total_gerado=0; map[k].lucro_bruto_gerado=0;
      map[k].receita=0; map[k].unidades=0; map[k].cancelados=0; map[k].devolucoes=0; order.push(k); }
    var g=map[k];
    g.receita_gerada+=Number(v.receita_gerada||0); g.unidades_vendidas+=Number(v.unidades_vendidas||0);
    g.custo_total_gerado+=Number(v.custo_total_gerado||0); g.lucro_bruto_gerado+=Number(v.lucro_bruto_gerado||0);
    g.receita+=Number(v.receita||0); g.unidades+=Number(v.unidades||0);
    g.cancelados+=Number(v.cancelados||0); g.devolucoes+=Number(v.devolucoes||0);
  });
  var out=order.map(function(k){ return map[k]; });
  // recalcula share (part. de vendas) após somar
  var tot=out.reduce(function(s,v){return s+Number(v.unidades||v.unidades_vendidas||0);},0)||1;
  out.forEach(function(v){ v.share=(Number(v.unidades||v.unidades_vendidas||0))/tot; });
  return out;
}
var ORDER_PAGE = "/pages/pedido";

function call(p){
  return new Promise(function(res,rej){
    var cb="mc_cb_"+Math.random().toString(36).slice(2),s=document.createElement("script");
    var to=setTimeout(function(){cl();rej(new Error("timeout"));},25000);
    function cl(){clearTimeout(to);try{delete window[cb];}catch(e){}if(s.parentNode)s.parentNode.removeChild(s);}
    window[cb]=function(d){cl();res(d);};
    var qs=Object.keys(p).map(function(k){return encodeURIComponent(k)+"="+encodeURIComponent(p[k]);}).join("&");
    s.src=MC_API+"?key="+encodeURIComponent(MC_TOKEN)+"&callback="+cb+"&"+qs;
    s.onerror=function(){cl();rej(new Error("net"));};
    document.head.appendChild(s);
  });
}
var BRL=function(n){return (Number(n)||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"});};
var PCT=function(n){return ((Number(n)||0)*100).toFixed(1)+"%";};
var NUM=function(n){return (Number(n)||0).toLocaleString("pt-BR");};
var DATE=function(s){if(!s)return"—";var d=new Date(s);return isNaN(d)?"—":d.toLocaleDateString("pt-BR");};
var SEC=function(s){s=Math.round(Number(s)||0);var m=Math.floor(s/60),r=s%60;return m?(m+"m"+(r<10?"0":"")+r+"s"):(r+"s");};
var kBRL=function(n){n=Number(n)||0;if(n>=1000000)return"R$"+(n/1000000).toFixed(1).replace(".",",")+"M";if(n>=1000)return"R$"+(n/1000).toFixed(1).replace(".",",")+"k";return"R$"+Math.round(n);};
var esc=function(s){return String(s==null?"":s).replace(/[&<>"]/g,function(c){return({"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"})[c];});};

/* ---- ícones (line) ---- */
var ICO={
  money:'<line x1="12" y1="2" x2="12" y2="22"/><path d="M17 6H9.5a3 3 0 0 0 0 6h5a3 3 0 0 1 0 6H6"/>',
  grid:'<rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>',
  calendar:'<rect x="3" y="4" width="18" height="18" rx="1"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>',
  info:'<circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="11"/><line x1="12" y1="7.5" x2="12.01" y2="7.5"/>',
  chart:'<line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>',
  compare:'<path d="M12 3v18"/><path d="M6 8l-4 4 4 4"/><path d="M18 8l4 4-4 4"/>',
  bolt:'<polygon points="13 2 4 14 12 14 11 22 20 10 12 10 13 2"/>',
  list:'<line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>',
  box:'<path d="M21 16V8a2 2 0 0 0-1-1.7l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.7l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.3 7 12 12 20.7 7"/><line x1="12" y1="22" x2="12" y2="12"/>',
  star:'<polygon points="12 2 15 9 22 9.3 16.5 14 18.5 21 12 17 5.5 21 7.5 14 2 9.3 9 9"/>',
  check:'<polyline points="20 6 9 17 4 12"/>',
  alert:'<path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>',
  clock:'<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>',
  trophy:'<path d="M8 21h8"/><path d="M12 17v4"/><path d="M7 4h10v5a5 5 0 0 1-10 0z"/><path d="M17 5h3v2a3 3 0 0 1-3 3"/><path d="M7 5H4v2a3 3 0 0 0 3 3"/>',
  eye:'<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/>',
  filter:'<polygon points="22 3 2 3 10 12.5 10 19 14 21 14 12.5 22 3"/>',
  route:'<circle cx="6" cy="19" r="3"/><path d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15"/><circle cx="18" cy="5" r="3"/>',
  cpu:'<rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><path d="M9 1v3M15 1v3M9 20v3M15 20v3M20 9h3M20 14h3M1 9h3M1 14h3"/>',
  bulb:'<path d="M9 18h6"/><path d="M10 22h4"/><path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14"/>',
  swap:'<polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>',
  pin:'<path d="M12 21s-7-6.5-7-11a7 7 0 0 1 14 0c0 4.5-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/>',
  cart:'<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>',
  gauge:'<path d="M12 15l4-6"/><circle cx="12" cy="15" r="2"/><path d="M3.5 18a10 10 0 1 1 17 0"/>'
};
function ic(name,cls){return '<svg class="pad-ic '+(cls||"")+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">'+(ICO[name]||"")+'</svg>';}

function getId(){try{return new URLSearchParams(window.location.search).get("id")||"";}catch(e){var m=window.location.search.match(/[?&]id=([^&]+)/);return m?decodeURIComponent(m[1]):"";};}
function fail(m){document.getElementById("mc-err").hidden=false;document.getElementById("mc-err").textContent="Erro: "+m;var l=document.getElementById("mc-loading");if(l)l.style.display="none";}

function scoreRing(score,size,color){
  size=size||52;color=color||"#fff200";
  var r=(size-7)/2,C=2*Math.PI*r,fill=C*(score/100);
  return '<svg width="'+size+'" height="'+size+'" viewBox="0 0 '+size+' '+size+'" style="transform:rotate(-90deg)">'
    +'<circle cx="'+size/2+'" cy="'+size/2+'" r="'+r+'" fill="none" stroke="#1e1e1e" stroke-width="5"/>'
    +'<circle cx="'+size/2+'" cy="'+size/2+'" r="'+r+'" fill="none" stroke="'+color+'" stroke-width="5"'
    +' stroke-dasharray="'+fill+' '+C+'" stroke-linecap="round"/></svg>';
}

var id=getId();
if(!id){document.getElementById("mc-loading").textContent="Nenhum produto na URL (?id=)";return;}

/* estado */
var DETAIL=null, ANALYTICS={}, PERIOD_CACHE={}, RANGE="all";
/* estado do calendário — declarado no topo pois o boot (localStorage) chama calBuild_ antes do trecho abaixo */
var CAL={view:null,start:null,end:null,_grid:null,_title:null,_range:null};
var CAL_MONTHS=["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
var CAL_OPEN=false;

/* dados da página de devoluções (fonte dos KPIs de devolução/troca) — cache-first */
var DEVSTATS=(function(){try{var s=JSON.parse(localStorage.getItem('pad_devs_v1'));return (s&&s.rows)?s:null;}catch(e){return null;}})();
function loadDevStats(){
  call({resource:'devolucoes_list'}).then(function(d){
    if(d&&d.rows){
      DEVSTATS={rows:d.rows,itens:d.itens||[]};
      try{localStorage.setItem('pad_devs_v1',JSON.stringify(DEVSTATS));}catch(e){}
      if(DETAIL)renderAll(RANGE);
    }
  }).catch(function(){});
}
loadDevStats();
function devCounts(pid,cut){
  if(!DEVSTATS)return null;
  var ids={};(DEVSTATS.itens||[]).forEach(function(it){ if(String(it.product_id)===String(pid)) ids[it.devolucao_id]=1; });
  var dev=0,tro=0;
  (DEVSTATS.rows||[]).forEach(function(r){
    if(!ids[r.id])return;
    var d=r.data_devolucao?new Date(r.data_devolucao):null;
    if(cut&&d&&d<cut)return;
    if(String(r.tipo)==='troca')tro++;else dev++;
  });
  return {dev:dev,tro:tro};
}

function rangeCutoff(r){
  r=String(r||"");
  var now=new Date();
  if(r.indexOf("~")>0){ var p=r.split("~"); var d=new Date(p[0]+"T00:00:00"); return isNaN(d)?null:d; }
  if(r==="hoje"){ var h=new Date(); h.setHours(0,0,0,0); return h; }
  if(r==="ontem"||r==="hoje_ontem"){ var y=new Date(now.getTime()-864e5); y.setHours(0,0,0,0); return y; }
  if(r==="7d")  return new Date(now.getTime()-7*864e5);
  if(r==="30d") return new Date(now.getTime()-30*864e5);
  if(r==="90d") return new Date(now.getTime()-90*864e5);
  if(r==="ano") return new Date(now.getFullYear(),0,1);
  if(r==="max") return new Date(now.getFullYear(),now.getMonth()-24,now.getDate());
  return null; // all
}
/* rótulos e detecção de atalho (mesmo conjunto da página de Aquisição) */
var PROD_PRESET_LABEL={hoje:'Hoje',hoje_ontem:'Hoje+Ontem','7d':'7 dias','30d':'30 dias',ano:'Ano',max:'Máximo'};
function prodPresetKey_(a,b){
  var t=new Date(); t.setHours(0,0,0,0);
  function iso(d){ return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
  var ea=iso(a), eb=iso(b), et=iso(t);
  if(ea===et&&eb===et) return 'hoje';
  if(ea===iso(new Date(t.getTime()-864e5))&&eb===et) return 'hoje_ontem';
  if(ea===iso(new Date(t.getTime()-6*864e5))&&eb===et) return '7d';
  if(ea===iso(new Date(t.getTime()-29*864e5))&&eb===et) return '30d';
  if(ea===iso(new Date(t.getFullYear(),0,1))&&eb===et) return 'ano';
  return null;
}

/* boot cache-first: renderiza instantâneo do localStorage e atualiza em background */
var BOOT_KEY='pad_boot_'+id, _bootRendered=false;
function bootRender(d,period,analytics){
  DETAIL=d;
  PERIOD_CACHE["all"]=period||[];
  ANALYTICS["all"]=analytics||null;
  var l=document.getElementById("mc-loading"); if(l)l.style.display="none";
  var first=!_bootRendered;
  if(first){ bindRange(); _bootRendered=true; }
  // renderiza no período ATUAL se já houver dados dele; senão, no "all" (pintura instantânea do cache)
  var rr=(PERIOD_CACHE[RANGE]!==undefined && ANALYTICS[RANGE]!==undefined)?RANGE:"all";
  renderAll(rr);
  if(first) applyInitialRange();   // aplica o período lembrado (ou o padrão 30 dias)
}
/* período inicial: restaura o último escolhido; se não houver, usa 30 dias (igual à Aquisição) */
function applyInitialRange(){
  var saved=null; try{ saved=JSON.parse(localStorage.getItem('mc_prod_range')); }catch(e){}
  var r=(saved&&saved.r)?saved.r:'30d';
  var label=(saved&&saved.label)?saved.label:'30 dias';
  setRange(r,label);
}
/* skeleton: estrutura completa da página em tom escuro enquanto os dados carregam */
function skeletonHtml(){
  function ln(w,h){return '<span class="skl-ln" style="width:'+w+';height:'+(h||10)+'px"></span>';}
  function cell(){return '<div class="skl-cell">'+ln('55%')+ln('75%',16)+'</div>';}
  function panel(bodyH,inner){return '<div class="pad-panel skl-panel"><div class="pad-panel-head">'+ln('140px',11)+'</div><div class="pad-panel-body" style="min-height:'+bodyH+'px">'+(inner||'')+'</div></div>';}
  var kpis='<div class="pad-kpi-row skl-panel">'+Array(6).fill('<div class="pad-kpi">'+ln('60%',9)+ln('80%',18)+'</div>').join('')+'</div>';
  var fin='<div class="skl-grid c4">'+Array(8).fill(cell()).join('')+'</div>';
  var bars='<div class="skl-bars">'+[60,90,45,75,30,55,80,40,65,50].map(function(h){return '<span class="skl-bar" style="height:'+h+'%"></span>';}).join('')+'</div>';
  var hero='<div class="pad-hero"><div class="pad-photo-wrap skl-panel skl-photo"></div><div class="pad-hero-side">'+panel(150,fin)+panel(180,bars)+'</div></div>';
  var ga='<div class="skl-grid c4">'+Array(8).fill(cell()).join('')+'</div>';
  var twoCol='<div class="pad-2col">'+panel(280,'<div class="skl-grid c2" style="padding:0">'+Array(6).fill(cell()).join('')+'</div>')+panel(280,bars)+'</div>';
  var cmp=panel(220,'<div class="skl-grid c4">'+Array(8).fill(cell()).join('')+'</div>');
  var gi=panel(160,'<div class="skl-grid c6">'+Array(12).fill(cell()).join('')+'</div>');
  var tbl=panel(200,Array(6).fill('<div class="skl-row">'+ln('12%')+ln('26%')+ln('8%')+ln('12%')+ln('16%')+'</div>').join(''));
  return '<div class="pad-skeleton">'+kpis+hero+panel(120,ga)+panel(230,bars)+twoCol+cmp+gi+tbl+'</div>';
}
(function(){
  var cached=false;
  try{
    var c=JSON.parse(localStorage.getItem(BOOT_KEY));
    if(c&&c.d&&c.d.product){ cached=true; bootRender(c.d,c.period,c.analytics); } // instantâneo
  }catch(e){}
  if(!cached){
    var l=document.getElementById("mc-loading"); if(l)l.style.display="none";
    document.getElementById("mc-product-wrap").innerHTML=skeletonHtml();
  }
})();
/* agrega products_clean (por variante) em linhas por PRODUTO no formato do products_period —
   leitura leve da planilha, sem reprocessar histórico de custo de todos os produtos */
function aggClean(rows){
  var map={},order=[];
  (rows||[]).forEach(function(v){
    var pid=String(v.product_id||'');if(!pid)return;
    var g=map[pid];
    if(!g){g=map[pid]={id:pid,product_id:pid,product_title:v.product_title||'',product_type:v.product_type||'',
      receita_gerada:0,lucro_bruto_gerado:0,custo_total_gerado:0,unidades_vendidas:0,pedidos_contendo:0,custo_unitario:''};order.push(pid);}
    g.receita_gerada+=Number(v.receita_gerada||0);
    g.lucro_bruto_gerado+=Number(v.lucro_bruto_gerado||0);
    g.custo_total_gerado+=Number(v.custo_total_gerado||0);
    g.unidades_vendidas+=Number(v.unidades_vendidas||0);
    g.pedidos_contendo=Math.max(g.pedidos_contendo,Number(v.pedidos_contendo||0));
    if(g.custo_unitario===''&&v.custo_unitario!==''&&v.custo_unitario!=null)g.custo_unitario=Number(v.custo_unitario);
  });
  return order.map(function(pid){var g=map[pid];g.margem_bruta=g.receita_gerada?g.lucro_bruto_gerado/g.receita_gerada:0;return g;});
}
/* carrega os 3 recursos de forma INDEPENDENTE: renderiza assim que o produto chega
   e vai re-renderizando conforme os demais respondem (nenhum timeout trava a página) */
var _got={};
function saveBoot(){
  if(!_got.d)return;
  try{localStorage.setItem(BOOT_KEY,JSON.stringify({ts:Date.now(),d:_got.d,period:_got.period||[],analytics:_got.analytics||null}));}catch(e){}
}
function tryRender(){
  if(!_got.d)return;
  bootRender(_got.d,_got.period||PERIOD_CACHE["all"]||[],(_got.analytics!==undefined?_got.analytics:ANALYTICS["all"])||null);
  saveBoot();
}
call({resource:"product",id:id}).then(function(d){
  if(d&&d.error){if(!_bootRendered)fail(d.error);return;}
  if(!d||!d.product){if(!_bootRendered)fail("Produto não encontrado.");return;}
  _got.d=d; tryRender();
}).catch(function(e){if(!_bootRendered)fail(e.message+" — recarregue a página.");});
call({resource:"products"}).then(function(r){          // products_clean: leve e cacheado no servidor
  _got.period=aggClean((r&&r.rows)||[]); window._padProducts=_got.period; tryRender();
}).catch(function(){});
call({resource:"product_analytics",id:id,range:"all"}).then(function(r){
  _got.analytics=r||null; tryRender();
}).catch(function(){});

/* ---- range picker ---- */
function calOpen_(show){
  var rp=document.getElementById("mc-rangepicker"), cal=document.getElementById("mc-cal");
  if(!rp) return;
  CAL_OPEN=!!show;
  rp.classList.toggle("open",CAL_OPEN);
  if(cal) cal.style.display=CAL_OPEN?"flex":"none";   // fallback: independe do CSS novo
  if(CAL_OPEN){ calSyncFromRange_(); calRender_(); }
}
/* reflete o período aplicado (RANGE) no calendário ao abrir — igual à página de Aquisição */
function calSyncFromRange_(){
  var t=new Date(); t.setHours(0,0,0,0); var r=String(RANGE||'');
  function set(a,b){ CAL.start=a; CAL.end=b; CAL.view=new Date((b||a||t).getFullYear(),(b||a||t).getMonth(),1); }
  if(r==='hoje') set(t,t);
  else if(r==='ontem'){ var y=new Date(t.getTime()-864e5); set(y,y); }
  else if(r==='hoje_ontem') set(new Date(t.getTime()-864e5),t);
  else if(r==='7d') set(new Date(t.getTime()-6*864e5),t);
  else if(r==='30d') set(new Date(t.getTime()-29*864e5),t);
  else if(r==='90d') set(new Date(t.getTime()-89*864e5),t);
  else if(r==='ano') set(new Date(t.getFullYear(),0,1),t);
  else if(r==='max'||r==='all'){ CAL.start=null; CAL.end=null; CAL.view=new Date(t.getFullYear(),t.getMonth(),1); }
  else if(r.indexOf('~')>0){ var p=r.split('~'); set(new Date(p[0]+'T00:00:00'), new Date(p[1]+'T00:00:00')); }
}
function bindRange(){
  try{ console.log("[mc-produto] painel v9 carregado"); }catch(e){}
  var rp=document.getElementById("mc-rangepicker");
  var tog=document.getElementById("mc-range-toggle");
  if(!tog || tog.__mcBound) return;   // trava: nunca liga os handlers duas vezes
  tog.__mcBound=true;
  // toggle SEMPRE ligado primeiro — nada depois pode impedir a abertura
  tog.addEventListener("click",function(e){ e.preventDefault(); e.stopPropagation(); calOpen_(!CAL_OPEN); });
  document.addEventListener("click",function(e){ if(CAL_OPEN && rp && !rp.contains(e.target)) calOpen_(false); });
  try{ calBuild_(); }catch(err){ try{ console.log("[mc-produto] calBuild erro:",err); }catch(e){} }
  var cal=document.getElementById("mc-cal");
  if(cal) cal.addEventListener("click",function(e){
    e.stopPropagation();
    var pre=e.target.closest("button[data-range]");
    if(pre){ calOpen_(false); setRange(pre.getAttribute("data-range"),pre.textContent.trim()); return; }
    if(e.target.closest("#mc-cal-prev")){ CAL.view=new Date(CAL.view.getFullYear(),CAL.view.getMonth()-1,1); calRender_(); return; }
    if(e.target.closest("#mc-cal-next")){ CAL.view=new Date(CAL.view.getFullYear(),CAL.view.getMonth()+1,1); calRender_(); return; }
    if(e.target.closest("#mc-cal-apply")){ if(!CAL.start) return; var en=CAL.end||CAL.start; calOpen_(false);
      var pk=prodPresetKey_(CAL.start,en);   // se o intervalo bate com um atalho, reaproveita o cache dele
      if(pk){ setRange(pk, PROD_PRESET_LABEL[pk]); } else { setRange(calISO_(CAL.start)+'~'+calISO_(en), calBRs_(CAL.start)+' - '+calBRs_(en)); }
      return; }
    var day=e.target.closest("button[data-date]");
    if(day){ var p=day.getAttribute("data-date").split("-"); var d=new Date(+p[0],+p[1]-1,+p[2]);
      if(!CAL.start||CAL.end){ CAL.start=d; CAL.end=null; } else { if(d<CAL.start){ CAL.end=CAL.start; CAL.start=d; } else CAL.end=d; }
      calRender_(); }
  });
}
/* ---- calendário (seletor de período com intervalo) — gerado 100% via JS ---- */
function calISO_(d){ return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
function calBR_(d){ return ('0'+d.getDate()).slice(-2)+'/'+('0'+(d.getMonth()+1)).slice(-2)+'/'+d.getFullYear(); }
function calBRs_(d){ return ('0'+d.getDate()).slice(-2)+'/'+('0'+(d.getMonth()+1)).slice(-2); }
function calSame_(a,b){ return a&&b&&a.getFullYear()===b.getFullYear()&&a.getMonth()===b.getMonth()&&a.getDate()===b.getDate(); }
function calBuild_(){
  var cal=document.getElementById("mc-cal"); if(!cal) return;
  var today=new Date(); today.setHours(0,0,0,0);
  CAL.end=today; CAL.start=new Date(today.getTime()-29*864e5); CAL.view=new Date(today.getFullYear(),today.getMonth(),1);
  // estilos inline no container (não depende do CSS estático)
  cal.style.cssText="position:absolute;top:calc(100% + 6px);right:0;z-index:60;display:none;background:#0f0f0f;border:1px solid #2a2a2a;box-shadow:0 18px 44px rgba(0,0,0,.6);flex-direction:row";
  var presets=[['hoje','Hoje'],['hoje_ontem','Hoje+Ontem'],['7d','7 dias'],['30d','30 dias'],['ano','Ano'],['max','Máximo']];
  var pBtn="text-align:left;padding:7px 10px;font-size:11px;text-transform:uppercase;letter-spacing:.04em;color:#8a8a8a;background:none;border:none;cursor:pointer;border-radius:6px;font-family:inherit;white-space:nowrap";
  cal.innerHTML=
    '<div style="display:flex;flex-direction:column;padding:8px;gap:2px;border-right:1px solid #1e1e1e;min-width:112px">'
      +presets.map(function(o){ return '<button type="button" data-range="'+o[0]+'" style="'+pBtn+'">'+o[1]+'</button>'; }).join('')
    +'</div>'
    +'<div style="padding:12px 14px 10px;width:262px">'
      +'<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px">'
        +'<button type="button" id="mc-cal-prev" style="width:28px;height:28px;background:none;border:none;color:#8a8a8a;cursor:pointer;font-size:20px;line-height:1">‹</button>'
        +'<span id="mc-cal-title" style="font-size:13px;font-weight:600;color:#f5f5f5"></span>'
        +'<button type="button" id="mc-cal-next" style="width:28px;height:28px;background:none;border:none;color:#8a8a8a;cursor:pointer;font-size:20px;line-height:1">›</button>'
      +'</div>'
      +'<div style="display:grid;grid-template-columns:repeat(7,1fr);text-align:center;font-size:10px;text-transform:uppercase;color:#8a8a8a;opacity:.7;margin-bottom:4px"><span>D</span><span>S</span><span>T</span><span>Q</span><span>Q</span><span>S</span><span>S</span></div>'
      +'<div id="mc-cal-grid" style="display:grid;grid-template-columns:repeat(7,1fr);gap:3px"></div>'
      +'<div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;padding-top:9px;border-top:1px solid #1e1e1e">'
        +'<span id="mc-cal-range" style="font-size:10.5px;color:#8a8a8a"></span>'
        +'<button type="button" id="mc-cal-apply" style="padding:6px 14px;background:#fff200;color:#0a0a0a;border:none;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;cursor:pointer;font-family:inherit">Aplicar</button>'
      +'</div>'
    +'</div>';
  // referências DIRETAS aos elementos recém-criados (evita getElementById pegar markup antigo/duplicado)
  CAL._grid=cal.querySelector("#mc-cal-grid");
  CAL._title=cal.querySelector("#mc-cal-title");
  CAL._range=cal.querySelector("#mc-cal-range");
  calRender_();
}
function calRender_(){
  var v=CAL.view; if(!v) return;
  var title=CAL._title, grid=CAL._grid, rt=CAL._range;
  if(!grid) return;
  if(title) title.textContent=CAL_MONTHS[v.getMonth()]+" "+v.getFullYear();
  var first=new Date(v.getFullYear(),v.getMonth(),1);
  var gridStart=new Date(first.getTime()-first.getDay()*864e5);
  var today=new Date(); today.setHours(0,0,0,0);
  var base="width:100%;height:32px;display:flex;align-items:center;justify-content:center;font-size:12px;background:none;border:none;cursor:pointer;font-family:inherit;border-radius:0;color:#f5f5f5";
  var html="";
  for(var i=0;i<42;i++){
    var d=new Date(gridStart.getFullYear(),gridStart.getMonth(),gridStart.getDate()+i);
    var st=base;
    var outM=d.getMonth()!==v.getMonth();
    if(outM) st+=";color:#4a4a4a";                               // fora do mês: cinza
    var isStart=calSame_(d,CAL.start), isEnd=calSame_(d,CAL.end);
    // dentro do intervalo: fundo amarelo translúcido; fora do mês selecionado = amarelo escuro
    if(CAL.start&&CAL.end&&d>=CAL.start&&d<=CAL.end&&!isStart&&!isEnd) st+=";background:rgba(255,242,0,.16);color:"+(outM?"#a5852a":"#f5f5f5");
    if((isStart||isEnd)&&CAL.end) st+=";background:#fff200;color:#0a0a0a;font-weight:700";
    if(isStart&&!CAL.end) st+=";background:#fff200;color:#0a0a0a;font-weight:700;border-radius:50%";
    if(calSame_(d,today)&&!isStart&&!isEnd) st+=";box-shadow:inset 0 0 0 1px #2a2a2a";
    html+='<button type="button" data-date="'+calISO_(d)+'" style="'+st+'">'+d.getDate()+'</button>';
  }
  grid.innerHTML=html;
  if(rt){ if(CAL.start){ var e=CAL.end||CAL.start; rt.textContent=calBR_(CAL.start)+((CAL.end&&!calSame_(CAL.start,CAL.end))?(' – '+calBR_(e)):''); } else rt.textContent="Selecione um período"; }
}
function setRange(r,label){
  RANGE=r;
  var lb=document.getElementById("mc-range-label"); if(lb) lb.textContent=label||r;
  try{ localStorage.setItem('mc_prod_range',JSON.stringify({r:r,label:label||r})); }catch(e){}   // lembra o período escolhido
  Array.prototype.forEach.call(document.querySelectorAll("#mc-cal button[data-range]"),function(x){ x.style.color=(x.getAttribute("data-range")===r)?"#fff200":"#8a8a8a"; });
  if(PERIOD_CACHE[r] && ANALYTICS[r]!==undefined){ renderAll(r); return; }
  var root=document.getElementById("mc-root"); root.classList.add("mc-recalc");
  Promise.all([
    PERIOD_CACHE[r]?Promise.resolve({rows:PERIOD_CACHE[r]}):call({resource:"products_period",range:r}),
    ANALYTICS[r]!==undefined?Promise.resolve(ANALYTICS[r]):call({resource:"product_analytics",id:id,range:r})
  ]).then(function(res){
    PERIOD_CACHE[r]=(res[0]&&res[0].rows)||[];
    ANALYTICS[r]=res[1]||null;
    root.classList.remove("mc-recalc"); renderAll(r);
  }).catch(function(){ root.classList.remove("mc-recalc"); renderAll(r); });
}

function renderAll(r){
  var detail=DETAIL, product=detail.product, row=detail.row, variants=detail.variants||[], allOrders=detail.orders||[];
  var pid=String(product.product_id||"");
  var allProds=PERIOD_CACHE[r]||[];
  var pr=allProds.filter(function(x){return String(x.id||x.product_id)===pid;})[0]||{};
  var A=ANALYTICS[r]||{};
  var ga=A.analytics||{has_ga4:false};

  var title=product.product_title||"Produto";
  var type=product.product_type||"";
  var isDrop=DROPSHIP.test(type);

  var receita=Number(pr.receita_gerada||0), lucro=Number(pr.lucro_bruto_gerado||0), custo=Number(pr.custo_total_gerado||0);
  var margem=Number(pr.margem_bruta||0), unidades=Number(pr.unidades_vendidas||0);
  var nOrders=0, avgTicket=0; // recalculados a partir dos pedidos filtrados (itens 1 e 3)
  var estoque=product.estoque!==""&&product.estoque!=null?Number(product.estoque):null;

  document.getElementById("mc-title").textContent=title;
  document.getElementById("mc-sub").textContent=(type||"Produto")+(row&&row.sku?" · SKU: "+row.sku:"");

  var totalRec=allProds.reduce(function(s,p){return s+Number(p.receita_gerada||0);},0);
  var totalLuc=allProds.reduce(function(s,p){return s+Number(p.lucro_bruto_gerado||0);},0);
  var participacao=totalRec?receita/totalRec:0, partLucro=totalLuc?lucro/totalLuc:0;
  var rankReceita=allProds.filter(function(p){return Number(p.receita_gerada||0)>receita;}).length+1;
  // PARES: produtos do MESMO TIPO com alguma venda no período — base de TODAS as médias e faixas mín/máx
  var peers=allProds.filter(function(p){ return String(p.product_type||'')===String(type||'') && Number(p.receita_gerada||0)>0; });
  if(peers.length<2) peers=allProds.filter(function(p){ return Number(p.receita_gerada||0)>0; }); // fallback: loja toda com venda
  var peerRec=peers.reduce(function(s,p){return s+Number(p.receita_gerada||0);},0);
  var peerLuc=peers.reduce(function(s,p){return s+Number(p.lucro_bruto_gerado||0);},0);
  var peerCst=peers.reduce(function(s,p){return s+Number(p.custo_total_gerado||0);},0);
  var avgRecLoja=peers.length?peerRec/peers.length:0, avgLucLoja=peers.length?peerLuc/peers.length:0;
  var avgTicketLoja=(function(){var t=0,n=0;peers.forEach(function(p){t+=Number(p.receita_gerada||0);n+=Number(p.pedidos_contendo||0);});return n?t/n:0;})();
  var avgMargemLoja=peerRec?(peerRec-peerCst)/peerRec:0;
  // faixas mín/máx dos pares (escala das barras de comparação)
  function pstat(get){ var vs=peers.map(get).filter(function(x){return isFinite(x);}); if(!vs.length)return null; return {min:Math.min.apply(null,vs),max:Math.max.apply(null,vs)}; }
  var peerRange={
    receita:pstat(function(p){return Number(p.receita_gerada||0);}),
    lucro:pstat(function(p){return Number(p.lucro_bruto_gerado||0);}),
    margem:pstat(function(p){return Number(p.margem_bruta||0);}),
    ticket:pstat(function(p){var n=Number(p.pedidos_contendo||0);return n?Number(p.receita_gerada||0)/n:NaN;}),
    unidades:pstat(function(p){return Number(p.unidades_vendidas||0);})
  };
  var avgUnLoja=peers.length?peers.reduce(function(s,p){return s+Number(p.unidades_vendidas||0);},0)/peers.length:0;
  var nComProds=allProds.filter(function(p){return Number(p.receita_gerada||0)>0;}).length||1;
  var rankPct=1-(rankReceita-1)/nComProds; // 1 = topo

  var stockStatus="—",stockCls="";
  if(!isDrop && estoque!==null){
    if(estoque<=0){stockStatus="Sem estoque";stockCls="pad-stock-out";}
    else if(estoque<10){stockStatus=estoque+" un. (baixo)";stockCls="pad-stock-low";}
    else{stockStatus=NUM(estoque)+" un.";stockCls="pad-stock-ok";}
  }
  // dias do período (p/ velocidade) — no "Máximo" usa o span real desde o 1º pedido
  var periodDays;
  if(r && r.indexOf("~")>0){ var _pp=r.split("~"); var _a=new Date(_pp[0]+"T00:00:00"), _b=new Date(_pp[1]+"T00:00:00"); periodDays=(!isNaN(_a)&&!isNaN(_b))?Math.max(1,Math.round((_b-_a)/864e5)+1):0; }
  else periodDays=(r==="hoje"||r==="ontem")?1:r==="hoje_ontem"?2:r==="7d"?7:r==="30d"?30:r==="90d"?90:r==="ano"?365:0;
  if(!periodDays){
    var first=null;
    allOrders.forEach(function(o){ if(o.created_at){ var d=new Date(o.created_at); if(!first||d<first) first=d; } });
    periodDays=first?Math.max(1,Math.round((Date.now()-first.getTime())/864e5)):30;
  }
  var vel=unidades/periodDays;
  var coverage=(!isDrop&&vel>0&&estoque>0)?Math.round(estoque/vel):null;

  var cut=rangeCutoff(r);
  // pedido sem created_at = excluído (removido/zerado na planilha) → não conta (item 1)
  var orders=allOrders.filter(function(o){ if(!o.created_at)return false; var d=new Date(o.created_at); if(isNaN(d))return false; return cut?d>=cut:true; });
  // pedidos DISTINTOS do produto (corrige contagem em bundles — item 3)
  nOrders=orders.length; avgTicket=nOrders?receita/nOrders:0;
  var paidOrdersN=orders.filter(function(o){ var s=String(o.status||'').toLowerCase(); return s!=='' && s.indexOf('não pago')<0 && s.indexOf('nao pago')<0 && s!=='cancelado' && s!=='devolvido' && s!=='troca'; }).length;

  // bundles/kits: unifica variações do MESMO tamanho e soma (item 5)
  var isBundle=BUNDLE.test(type)||BUNDLE.test(title);
  var variantsBase=isBundle?unifyBySize(variants):variants;
  var variantsSorted=variantsBase.slice().sort(function(a,b){return Number(b.receita_gerada||0)-Number(a.receita_gerada||0);});
  var maxVarRec=variantsSorted[0]?Number(variantsSorted[0].receita_gerada||0)||1:1;

  var weekdaySales=Array(7).fill(0), weekdayNames=["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"];
  orders.forEach(function(o){ if(o.created_at) weekdaySales[new Date(o.created_at).getDay()]+=1; });
  var maxWd=Math.max.apply(null,weekdaySales)||1;
  var hourSales=Array(24).fill(0);
  orders.forEach(function(o){ if(o.created_at) hourSales[new Date(o.created_at).getHours()]+=1; });
  var peakHour=hourSales.indexOf(Math.max.apply(null,hourSales));
  var bestWd=weekdaySales.indexOf(Math.max.apply(null,weekdaySales));
  var weekendSales=weekdaySales[0]+weekdaySales[6], weekdayS=weekdaySales.slice(1,6).reduce(function(a,b){return a+b;},0);

  // ---- render ----
  var html="";

  // INSIGHTS — motor de destaque (só o que salta aos olhos), botão flutuante + drawer
  var noStock=isDrop||isBundle||DROPSHIP.test(title);
  var aiHtml=aiPanel({ga:ga,funil:A.funil,origem:A.origem||[],variantes:isBundle?unifyBySize(A.variantes||[]):(A.variantes||[]),storeAvg:A.storeAvg,
    receita:receita,lucro:lucro,custo:custo,margem:margem,unidades:unidades,participacao:participacao,rankReceita:rankReceita,rankPct:rankPct,
    avgMargemLoja:avgMargemLoja,avgRecLoja:avgRecLoja,avgTicketLoja:avgTicketLoja,ticket:avgTicket,
    noStock:noStock,estoque:estoque,coverage:coverage,peakHour:peakHour,
    bestWdName:(bestWd>=0?weekdayNames[bestWd]:""),weekendSales:weekendSales,weekdayS:weekdayS,
    orders:orders.length,title:title,timing:A.timing,comportamento:A.comportamento});

  // ANÁLISE FINANCEIRA — 8 células, 2 linhas × 4 colunas, com ícones (item 4)
  var lucroUn = (custo&&unidades)?((receita-custo)/unidades):null;
  // custo BASE do produto (custo unitário atual), não o custo somado dos pedidos
  var custoBase=Number(pr.custo_unitario!=null&&pr.custo_unitario!==''?pr.custo_unitario:(row&&row.custo_unitario)||0);
  var finGrid='<div class="pad-fin-grid">'
    +stat("Receita",BRL(receita),"acc",receita,"brl","money")
    +stat("Custo bruto",BRL(custo),"bad",custo,"brl","box")
    +stat("Lucro bruto",BRL(lucro),lucro>=0?"good":"bad",lucro,"brl","chart")
    +stat("Margem bruta",PCT(margem),margem>=0.3?"good":margem>=0.15?"warn":"bad",margem,"pct","trophy")
    +stat("Ticket médio",BRL(avgTicket),"",avgTicket,"brl","compare")
    +stat("Lucro bruto / un.",lucroUn!=null?BRL(lucroUn):"—",lucroUn!=null?"good":"",lucroUn!=null?lucroUn:0,"brl","money")
    +stat("Pedidos",NUM(nOrders)+' / '+NUM(unidades)+'<span class="pad-stat-sub">un</span>',"",nOrders,"","list")
    +stat("Velocidade",(vel>0?(vel.toFixed(2).replace('.',',')+'<span class="pad-stat-sub"> un/dia</span>'):'—'),"",vel,"","bolt")
    +'</div>';

  // dataset unificado das variantes (todas as métricas num só lugar)
  var vSourceRaw = (A.variantes && A.variantes.length) ? A.variantes
    : variantsSorted.map(function(v){ return { tamanho:(v.variant_title||v.tamanho), variant_title:(v.variant_title||v.tamanho), unidades:v.unidades_vendidas, receita:v.receita_gerada, cancelados:0, devolucoes:0 }; });
  // bundles: dropdown de camiseta (modelo) — padrão "Todas"
  var vModels=[];
  if(isBundle){
    var seenM={};
    vSourceRaw.forEach(function(v){ var mk=modelKey(v); if(mk&&!seenM[mk]){ seenM[mk]=1; vModels.push(mk); } });
    vModels.sort(function(a,b){ return a.localeCompare(b,'pt',{sensitivity:'base'}); });
  }
  window._padVarRaw=vSourceRaw;
  window._padCatVars=variants||[]; // catálogo (base p/ tamanhos sem venda)
  var catSizes=(variants||[]).map(function(v){ return v.variant_title||v.tamanho||''; });
  var vSource = isBundle ? unifyBySize(vSourceRaw) : vSourceRaw;
  var vdata = padSizes(buildVdata(vSource), catSizes);
  var VMETRICS=[["receita","Receita"],["share","Participação"],["cd","Cancel/Devol"]];
  var vtabs='<div class="pad-vtabs" id="pad-vtabs">'+VMETRICS.map(function(m,i){
      return '<button type="button" data-m="'+m[0]+'"'+(i===0?' class="is-active"':'')+'>'+m[1]+'</button>';
    }).join("")+'</div>';
  var vModelSel = (isBundle && vModels.length>1)
    ? '<select id="pad-vmodel" class="pad-vmodel"><option value="">Todas as variantes</option>'
      +vModels.map(function(m){ return '<option value="'+esc(m)+'">'+esc(m)+'</option>'; }).join("")+'</select>'
    : '';
  var varBody = vdata.length ? '<div class="pad-vcols" id="pad-vcols" data-metric="receita">'+vdata.map(vcolHtml).join("")+'</div>'
    : '<p class="mc-empty" style="padding:4px 0">Sem venda de variantes no período</p>';
  var variantesPanel='<div class="pad-panel grow"><div class="pad-panel-head"><h2>'+ic("grid")+'Variantes</h2>'
    +'<div class="pad-vctrls">'+(vdata.length?vtabs:'')+vModelSel+'</div></div>'
    +'<div class="pad-panel-body">'+varBody+'</div></div>';

  var photoCell = product.image
    ? '<div class="pad-photo-wrap"><img class="pad-photo" src="'+esc(bigImg(product.image))+'" alt="'+esc(title)+'"></div>'
    : '<div class="pad-panel" style="display:flex;align-items:center;justify-content:center;color:var(--line2)">sem foto</div>';

  // foto à ESQUERDA; à DIREITA: análise financeira + (insights gerais / comparação com a categoria)
  html+='<div class="pad-hero">'
    +photoCell
    +'<div class="pad-hero-side">'
      +panelG("Análise financeira","money",finGrid,false)
      +generalInsights({ga:ga,origem:A.origem||[],peakHour:peakHour,bestWd:bestWd>=0?weekdayNames[bestWd]:"—",
        visitasCompra:(ga.pageviews&&paidOrdersN)?(ga.pageviews/paidOrdersN):null,
        comportamento:A.comportamento||{}, variantes:A.variantes||[], orders:orders,
        vel:vel, coverage:coverage, insightChart:A.insightChart||null})
    +'</div>'
    +'</div>';

  // 10 + 11 — GA4 PERFORMANCE e FUNIL juntos (sem gap)
  window._padFunil=A.funil||null; window._padPid=String(pid); window._padGa=ga; window._padTitle=title;
  html+='<div class="pad-stack">'
    +'<div class="pad-panel">'
    +'<div class="pad-panel-head"><h2>'+ic("eye")+'Performance da página (GA4)</h2>'
      +funnelCompareCtrl()+'</div>'
    +'<div class="pad-panel-body" style="padding:0"><div id="pad-ga-body">'+ga4Grid_(ga,null)+'</div></div></div>'
    +'<div class="pad-panel"><div class="pad-panel-body" style="padding:0">'
      +'<div id="pad-funnel-body">'+funnelFlow(A.funil,null)+'</div>'
    +'</div></div>'
    +'</div>';

  // dia da semana em BARRAS HORIZONTAIS
  var topWd=weekdaySales.indexOf(maxWd);
  var wdCols='<div class="pad-wdays-h">'+weekdayNames.map(function(d,i){
      var v=weekdaySales[i], pct=maxWd?v/maxWd:0;
      return '<div class="pad-wdh'+(i===topWd&&v>0?' is-top':'')+'" title="'+d+': '+NUM(v)+' vendas">'
        +'<span class="pad-wdh-lab">'+d+'</span>'
        +'<div class="pad-wdh-track"><div class="pad-wd-fill" data-w="'+(pct*100).toFixed(0)+'"></div></div>'
        +'<span class="pad-wdh-val" data-to="'+v+'" data-fmt="num">0</span></div>';
    }).join("")+'</div>';
  var weekdayPanel='<div class="pad-panel"><div class="pad-panel-head"><h2>'+ic("calendar")+'Vendas por dia da semana</h2></div>'
    +'<div class="pad-panel-body" style="padding:0">'+wdCols+'</div></div>';

  // VARIANTES (tamanhos) à esquerda + VENDAS POR DIA DA SEMANA à direita (itens 3/4)
  html+='<div class="pad-2col">'+variantesPanel+weekdayPanel+'</div>';

  // ORIGEM DAS VENDAS à esquerda + TEMPO ATÉ A COMPRA à direita
  html+='<div class="pad-2col">'+srcPanel(A.origem||[])+timingPanel(A.timing)+'</div>';

  // 16 — COMPARAÇÃO COM A MÉDIA DA LOJA (pares = mesmo tipo, com venda; barras escaladas no mín/máx dos pares)
  var dc=devCounts(pid,cut);
  // média/faixa de devoluções+trocas entre os pares (fonte: página de devoluções)
  var avgDevol=null;
  if(DEVSTATS&&peers.length){
    var prodOfDev={};
    (DEVSTATS.itens||[]).forEach(function(it){ (prodOfDev[it.devolucao_id]=prodOfDev[it.devolucao_id]||{})[String(it.product_id||'')]=1; });
    var devMap={};
    (DEVSTATS.rows||[]).forEach(function(r){
      var d0=r.data_devolucao?new Date(r.data_devolucao):null; if(cut&&d0&&d0<cut)return;
      Object.keys(prodOfDev[r.id]||{}).forEach(function(p){ devMap[p]=(devMap[p]||0)+1; });
    });
    var dvals=peers.map(function(p){ return devMap[String(p.id||p.product_id)]||0; });
    avgDevol=dvals.reduce(function(a,b){return a+b;},0)/dvals.length;
    peerRange.devol={min:Math.min.apply(null,dvals),max:Math.max.apply(null,dvals)};
  }
  html+=comparePanel({
    receita:receita, avgReceita:avgRecLoja,
    lucro:lucro, avgLucro:avgLucLoja,
    conversao:ga.conversao, avgConversao:A.storeAvg&&A.storeAvg.conversao,
    atc:ga.atc_rate, avgAtc:A.storeAvg&&A.storeAvg.atc_rate,
    tempo:ga.tempo_medio_seg, avgTempo:A.storeAvg&&A.storeAvg.tempo_medio_seg,
    ticket:avgTicket, avgTicket:avgTicketLoja,
    devol:dc?dc.dev:devolTotal(A.variantes), trocas:dc?dc.tro:0, avgDevol:avgDevol, cancel:cancelTotal(A.variantes),
    unidades:unidades, avgUnidades:avgUnLoja,
    margem:margem, avgMargem:avgMargemLoja,
    range:peerRange, tipo:type, nPeers:peers.length
  });

  // PEDIDOS
  if(orders.length){
    html+='<div class="pad-panel">'
      +'<div class="pad-panel-head"><h2>'+ic("list")+'Pedidos com este produto</h2><span class="pad-tag">'+NUM(orders.length)+'</span></div>'
      +'<div class="pad-panel-body" style="padding:0">'
      +'<table class="pad-tbl"><thead><tr><th>Data</th><th>Cliente</th><th class="r">Qtd</th><th class="r">Lucro</th><th>Status</th></tr></thead><tbody>'
      +orders.slice(0,25).map(function(o){
        var stc="mc-pill s-"+(o.status||"").replace(/[^a-zà-ú]/gi,"").toLowerCase();
        return '<tr class="pad-order-tr" data-oid="'+esc(o.id)+'">'
          +'<td>'+DATE(o.created_at)+'</td>'
          +'<td>'+esc(o.customer_name||"—")+'</td>'
          +'<td class="r">'+NUM(o.qtd)+'</td>'
          +'<td class="r '+(Number(o.lucro)<0?"bad":"")+'">'+(o.lucro===""||o.lucro==null?"—":BRL(o.lucro))+'</td>'
          +'<td><span class="'+stc+'">'+esc(o.status||"—")+'</span></td></tr>';
      }).join("")
      +(orders.length>25?'<tr><td colspan="5" style="color:var(--mut);font-size:10px;padding:8px 10px">... mais '+(orders.length-25)+' pedidos</td></tr>':'')
      +'</tbody></table></div></div>';
  }

  var wrap=document.getElementById("mc-product-wrap");
  wrap.innerHTML=html+aiHtml;

  // pós-render: barras crescem + números embaralham (recálculo)
  requestAnimationFrame(function(){
    Array.prototype.forEach.call(wrap.querySelectorAll(".pad-bar-fill,.pad-fun-fill,.pad-src-fill,.pad-cx-fill"),function(b){ b.style.width=(b.getAttribute("data-w")||0)+"%"; });
    Array.prototype.forEach.call(wrap.querySelectorAll(".pad-vcol-fill,.pad-vf-fill,.pad-wd-fill,.pad-ic-fill"),function(b){
      if(b.hasAttribute("data-w")) b.style.width=(b.getAttribute("data-w")||0)+"%";
      else b.style.height=(b.getAttribute("data-h")||0)+"%";
    });
    Array.prototype.forEach.call(wrap.querySelectorAll("[data-to]"),scrambleVal);
  });
  wrap.querySelectorAll(".pad-order-tr").forEach(function(tr){
    tr.addEventListener("click",function(){ var oid=tr.getAttribute("data-oid"); if(oid) window.location.href=ORDER_PAGE+"?id="+encodeURIComponent(oid); });
  });
  wireAiDrawer(wrap);
  wireVariantTabs(wrap);
  wireInsightChart(wrap);
  wireInsightCmp_(wrap);
  wireFunnelCompare(wrap);
  wireGaTips_(wrap);
  wireFunnelTip_(wrap);
}
function wireFunnelCompare(wrap){
  var inp=wrap.querySelector('#pad-cmp-inp'); if(!inp) return;
  var boxEl=wrap.querySelector('#pad-cmp-box'), caret=wrap.querySelector('#pad-cmp-caret');
  var list=wrap.querySelector('#pad-cmp-list'), clear=wrap.querySelector('#pad-cmp-clear'), body=wrap.querySelector('#pad-funnel-body'), gaBody=wrap.querySelector('#pad-ga-body');
  if(!list||!body) return;
  function fillGa(cmpGa,cmpName){ if(!gaBody) return; gaBody.innerHTML=ga4Grid_(window._padGa, cmpGa, cmpName);
    try{ gaBody.querySelectorAll("[data-to]").forEach(scrambleVal); }catch(e){} }
  var prods=(window._padProducts||[]).filter(function(p){ return String(p.product_id)!==String(window._padPid); });
  function setOpen(o){ if(boxEl) boxEl.classList.toggle('open',o); list.hidden=!o; }
  function hideList(){ setOpen(false); }
  function render(q){
    q=String(q||'').toLowerCase().trim();
    var res=prods.filter(function(p){ return String(p.product_title||'').toLowerCase().indexOf(q)>=0; }).slice(0,50);
    list.innerHTML=res.length
      ? res.map(function(p){ return '<button type="button" class="pad-cmp-opt" data-id="'+esc(p.product_id)+'" data-name="'+esc(p.product_title||'')+'">'+esc(p.product_title||('Produto '+p.product_id))+'</button>'; }).join('')
      : '<div class="pad-cmp-empty">Nenhum produto</div>';
    setOpen(true);
  }
  inp.addEventListener('focus',function(){ render(inp.value); });
  inp.addEventListener('input',function(){ render(inp.value); });
  if(caret) caret.addEventListener('click',function(e){ e.stopPropagation(); if(list.hidden){ inp.focus(); render(inp.value); } else hideList(); });
  list.addEventListener('click',function(e){
    var b=e.target.closest('.pad-cmp-opt'); if(!b) return;
    var pid=b.getAttribute('data-id'), name=b.getAttribute('data-name');
    inp.value=name; hideList(); clear.hidden=false; if(caret) caret.hidden=true; body.classList.add('is-loading');
    call({resource:'product_analytics',id:pid,range:(typeof RANGE!=='undefined'?RANGE:'all')}).then(function(rr){
      body.classList.remove('is-loading');
      body.innerHTML=funnelFlow(window._padFunil,{name:name,funil:(rr&&rr.funil)||null});
      fillGa((rr&&rr.analytics)||{}, name);
    }).catch(function(){ body.classList.remove('is-loading'); });
  });
  clear.addEventListener('click',function(){ inp.value=''; clear.hidden=true; if(caret) caret.hidden=false; hideList(); body.innerHTML=funnelFlow(window._padFunil,null); fillGa(null,null); });
  document.addEventListener('click',function(e){ if(boxEl && !boxEl.contains(e.target)) hideList(); });
}
/* tooltip próprio das barras do funil (mostra o nome do produto da barra) */
function wireFunnelTip_(wrap){
  var box=wrap.querySelector('#pad-funnel-body'); if(!box || box.__ftip) return; box.__ftip=true;
  box.style.position='relative';
  box.addEventListener('mouseover',function(e){
    var r=e.target.closest('rect[data-name]'); if(!r) return;
    var w=box.querySelector('.pad-ff-tip'); if(!w) return;
    var isCmp=r.classList.contains('pad-ff-b2');
    w.innerHTML='<div class="tip-h"><i class="dot '+(isCmp?'c':'p')+'"></i>'+r.getAttribute('data-name')+'</div>'
      +'<div class="tip-r"><span>Total</span><b>'+r.getAttribute('data-total')+'</b></div>'
      +'<div class="tip-r"><span>% do topo</span><b>'+r.getAttribute('data-pct')+'</b></div>';
    w.hidden=false;
    var br=box.getBoundingClientRect(), rr=r.getBoundingClientRect();
    var x=rr.left-br.left+rr.width/2, y=rr.top-br.top;
    w.style.left=Math.max(4,Math.min(br.width-w.offsetWidth-4, x-w.offsetWidth/2))+'px';
    w.style.top=Math.max(2,(y-w.offsetHeight-8))+'px';
  });
  box.addEventListener('mouseout',function(e){ if(!e.target.closest('rect[data-name]'))return; var w=box.querySelector('.pad-ff-tip'); if(w) w.hidden=true; });
}

/* Variantes · desempenho — troca a métrica do gráfico ao clicar nos botões */
function wireVariantTabs(wrap){
  var box=wrap.querySelector("#pad-vcols"); if(!box) return;
  var tabs=wrap.querySelector("#pad-vtabs");
  function paint(metric){
    var cols=Array.prototype.slice.call(box.querySelectorAll(".pad-vcol"));
    var topVal=-1, topEl=null;
    if(metric==="cd"){
      // aba combinada: 2 barras por variante (cancelamentos + devoluções)
      var max=0; cols.forEach(function(c){
        max=Math.max(max, Number(c.getAttribute("data-cancelados"))||0, Number(c.getAttribute("data-devolucoes"))||0);
      }); max=max||1;
      cols.forEach(function(c){
        var ca=Number(c.getAttribute("data-cancelados"))||0, dv=Number(c.getAttribute("data-devolucoes"))||0;
        var sum=ca+dv;
        if(sum>topVal){ topVal=sum; topEl=c; }
        c.querySelector(".pad-vcol-fill").style.height=(ca/max*100).toFixed(1)+"%";
        c.querySelector(".pad-vcol-fill.f2").style.height=(dv/max*100).toFixed(1)+"%";
        var ve=c.querySelector(".pad-vcol-val");
        if(ve._t){ cancelAnimationFrame(ve._t); ve._t=null; }
        ve.innerHTML='<span class="vv-c">'+NUM(ca)+'</span> · <span class="vv-d">'+NUM(dv)+'</span>';
      });
    } else {
      var max2=0; cols.forEach(function(c){ max2=Math.max(max2, Number(c.getAttribute("data-"+metric))||0); }); max2=max2||1;
      var fmt = metric==="receita"?"kbrl":metric==="share"?"pct":"num";
      cols.forEach(function(c){
        var val=Number(c.getAttribute("data-"+metric))||0;
        if(val>topVal){ topVal=val; topEl=c; }
        c.querySelector(".pad-vcol-fill").style.height=(val/max2*100).toFixed(1)+"%";
        c.querySelector(".pad-vcol-fill.f2").style.height="0%";
        var ve=c.querySelector(".pad-vcol-val"); ve.setAttribute("data-to",val); ve.setAttribute("data-fmt",fmt); scrambleVal(ve);
      });
    }
    cols.forEach(function(c){ c.classList.remove("is-top"); });
    if(topEl && topVal>0) topEl.classList.add("is-top");
    box.setAttribute("data-metric",metric);
  }
  if(tabs) tabs.addEventListener("click",function(e){
    var b=e.target.closest("button[data-m]"); if(!b) return;
    Array.prototype.forEach.call(tabs.children,function(x){ x.classList.remove("is-active"); });
    b.classList.add("is-active"); paint(b.getAttribute("data-m"));
  });
  // bundles: dropdown de camiseta — filtra as variantes e redesenha mantendo a métrica ativa
  var msel=wrap.querySelector("#pad-vmodel");
  if(msel) msel.addEventListener("change",function(){
    var raw=window._padVarRaw||[];
    var flt=msel.value?raw.filter(function(v){ return modelKey(v)===msel.value; }):raw;
    // tamanhos do catálogo da variante escolhida (ou de todas) — inclui os sem venda, na ordem fixa
    var cat=(window._padCatVars||[]).filter(function(v){ return !msel.value||modelKey(v)===msel.value; })
      .map(function(v){ return v.variant_title||v.tamanho||''; });
    var vd=padSizes(buildVdata(unifyBySize(flt)),cat);
    box.innerHTML=vd.length?vd.map(vcolHtml).join(""):'<p class="mc-empty" style="padding:4px 0">Sem vendas desse modelo no período</p>';
    var act=tabs&&tabs.querySelector(".is-active");
    paint(act?act.getAttribute("data-m"):"receita");
  });
  requestAnimationFrame(function(){ paint("receita"); });
}

/* controla o botão flutuante + drawer do diagnóstico (itens 3 e 4) */
function wireAiDrawer(wrap){
  var fab=wrap.querySelector("#pad-ai-fab"), drawer=wrap.querySelector("#pad-ai-drawer");
  if(!fab||!drawer) return;
  // botão surge subindo
  setTimeout(function(){ fab.classList.add("is-visible"); }, 220);
  function open(){
    drawer.classList.add("open");
    // itens aparecem em cascata
    Array.prototype.forEach.call(drawer.querySelectorAll(".pad-aid-item"),function(el,i){
      el.style.transitionDelay=(90+i*70)+"ms";
    });
  }
  function close(){
    drawer.classList.remove("open");
    Array.prototype.forEach.call(drawer.querySelectorAll(".pad-aid-item"),function(el){ el.style.transitionDelay="0ms"; });
  }
  fab.addEventListener("click",function(e){ e.stopPropagation(); drawer.classList.contains("open")?close():open(); });
  drawer.querySelector(".pad-aid-close").addEventListener("click",close);
  // fecha ao clicar fora — vincula ao documento só uma vez (usa os elementos atuais do DOM)
  if(!window._padAiDocBound){
    window._padAiDocBound=true;
    document.addEventListener("click",function(e){
      var dr=document.getElementById("pad-ai-drawer"), fb=document.getElementById("pad-ai-fab");
      if(dr&&dr.classList.contains("open") && !dr.contains(e.target) && (!fb||!fb.contains(e.target))) dr.classList.remove("open");
    });
  }
}

/* ---------- blocos ---------- */
function gacell(lbl,val,fmt,cmpVal,hi,cmpName){
  var f = fmt==="pct"?PCT:fmt==="sec"?SEC:NUM;
  var disp = fmt==="pct"?PCT(0):fmt==="sec"?"0s":"0";
  var delta='';
  if(cmpVal!=null && isFinite(cmpVal)){
    var v=Number(val)||0, c=Number(cmpVal)||0, d=v-c;
    var up=d>=0, good=(hi?up:!up), arrow=up?'▲':'▼', dAbs=f(Math.abs(d));
    delta='<span class="pad-ga-delta '+(good?'good':'bad')+'" data-m="'+esc(lbl)+'" data-v="'+esc(f(v))+'" data-c="'+esc(f(c))+'" data-d="'+(up?'+':'−')+esc(dAbs)+'" data-good="'+(good?1:0)+'" data-cmp="'+esc(cmpName||'Comparado')+'">'+arrow+dAbs+'</span>';
  }
  return '<div class="pad-ga"><span class="pad-ga-lbl">'+lbl+'</span>'
    +'<span class="pad-ga-valrow"><span class="pad-ga-val" data-to="'+(Number(val)||0)+'" data-fmt="'+fmt+'">'+disp+'</span>'+delta+'</span></div>';
}
/* grid de métricas GA4; cmpGa (opcional) mostra o delta vs produto comparado */
function ga4Grid_(ga, cmpGa, cmpName){
  if(!ga || !ga.has_ga4) return '<p class="pad-note" style="padding:14px 15px">Sem dados de GA4 por produto neste período. Os dados aparecem após a próxima sincronização do Midnight Sync (aba <b>ga4_products</b>).</p>';
  var g=cmpGa||{};
  var M=[
    ["Visualizações", ga.pageviews||ga.item_views, (g.pageviews||g.item_views), "num", true],
    ["Usuários únicos", ga.usuarios, g.usuarios, "num", true],
    ["Sessões", ga.sessions, g.sessions, "num", true],
    ["Tempo médio", ga.tempo_medio_seg, g.tempo_medio_seg, "sec", true],
    ["Engagement", ga.engagement_rate, g.engagement_rate, "pct", true],
    ["Scroll médio", ga.scroll_pct, g.scroll_pct, "pct", true],
    ["Bounce rate", ga.bounce_rate, g.bounce_rate, "pct", false],
    ["Conversão", ga.conversao, g.conversao, "pct", true]
  ];
  return '<div class="pad-ga-grid">'+M.map(function(m){
    return gacell(m[0], m[1], m[3], cmpGa?m[2]:null, m[4], cmpName);
  }).join('')+'</div><div class="pad-ga-tip" hidden></div>';
}
/* tooltip próprio dos deltas dos KPIs GA4 (janela estilizada, não o title nativo) */
function wireGaTips_(wrap){
  var box=wrap.querySelector('#pad-ga-body'); if(!box || box.__tip) return; box.__tip=true;
  box.style.position='relative';
  box.addEventListener('mouseover',function(e){
    var cell=e.target.closest('.pad-ga'); if(!cell || !box.contains(cell)) return;
    var d=cell.querySelector('.pad-ga-delta'); if(!d) return;   // só há tooltip quando está comparando
    var tip=box.querySelector('.pad-ga-tip'), grid=box.querySelector('.pad-ga-grid'); if(!tip||!grid) return;
    var good=d.getAttribute('data-good')==='1';
    tip.innerHTML='<div class="tip-h">'+d.getAttribute('data-m')+'</div>'
      +'<div class="tip-r"><span><i class="dot p"></i>Este produto</span><b>'+d.getAttribute('data-v')+'</b></div>'
      +'<div class="tip-r"><span><i class="dot c"></i>'+(d.getAttribute('data-cmp')||'Comparado')+'</span><b>'+d.getAttribute('data-c')+'</b></div>'
      +'<div class="tip-r diff '+(good?'good':'bad')+'"><span>Diferença</span><b>'+d.getAttribute('data-d')+'</b></div>';
    tip.hidden=false;
    // abaixo da linha dos KPIs, centralizado sob a célula
    var br=box.getBoundingClientRect(), cr=cell.getBoundingClientRect(), gr=grid.getBoundingClientRect();
    var x=cr.left-br.left+cr.width/2;
    tip.style.left=Math.max(4,Math.min(br.width-tip.offsetWidth-4, x-tip.offsetWidth/2))+'px';
    tip.style.top=((gr.bottom-br.top)+6)+'px';
  });
  box.addEventListener('mouseout',function(e){
    var cell=e.target.closest('.pad-ga'); if(!cell) return;
    if(e.relatedTarget && cell.contains(e.relatedTarget)) return;
    var tip=box.querySelector('.pad-ga-tip'); if(tip) tip.hidden=true;
  });
}
/* funil vertical estilo dashboard (item 6) */
var FUN_ICO={
  page:'<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>',
  view:'<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-5-5L5 21"/>',
  cart:'<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>',
  checkout:'<rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/>',
  buy:'<polyline points="20 6 9 17 4 12"/>'
};
function funIc(k){return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'+(FUN_ICO[k]||"")+'</svg>';}
function funnelStages_(f){
  f=f||{};
  return [
    {n:"Página",ic:"page",v:Number(f.pagina||f.view_item||0)},
    {n:"Viu produto",ic:"view",v:Number(f.view_item||0)},
    {n:"Carrinho",ic:"cart",v:Number(f.add_to_cart||0)},
    {n:"Checkout",ic:"checkout",v:Number(f.begin_checkout||0)},
    {n:"Compra",ic:"buy",v:Number(f.compra||0)}
  ];
}
/* funil de conversão como GRÁFICO DE BARRAS. base = produto; cmp = {name,funil} opcional (2 barras por etapa).
   Cores iguais às da comparação com a categoria: produto = amarelo, comparado = azul. */
function funnelFlow(f, cmp){
  var base=funnelStages_(f);
  if(!(base[0].v||base[4].v)) return '<p class="pad-note" style="padding:14px 15px">Sem dados de funil GA4 por produto neste período.</p>';
  var cs=(cmp&&cmp.funil)?funnelStages_(cmp.funil):null;
  var hasCmp=!!(cs&&cs[0].v);
  var W=580,H=192,padL=14,padR=14,baseY=158,topY=30,plotH=baseY-topY,N=base.length;
  var slotW=(W-padL-padR)/N;
  var baseName=String(window._padTitle||'Este produto');
  // escala com RAIZ QUADRADA: amplia valores pequenos (ex.: compra ~1%) p/ enxergar a diferença
  function hp(p){ p=Math.max(0,Number(p)||0); return p>0 ? Math.max(3, Math.sqrt(p)*plotH) : 0; }
  // linhas de grade horizontais (4)
  var grid='';
  for(var g=0;g<=4;g++){ var gy=(baseY-plotH*g/4).toFixed(1); grid+='<line class="pad-ff-grid" x1="'+padL+'" y1="'+gy+'" x2="'+(W-padR)+'" y2="'+gy+'"/>'; }
  var t0=base[0].v||1, tc0=cs?(cs[0].v||1):1, bars='', labels='';
  function pctTxt(p){ return (p*100).toFixed(p<0.1?1:0)+'%'; }
  function bar_(cls,x,hgt,w,name,total,pct){
    return '<rect class="pad-ff-bar '+cls+'" x="'+x.toFixed(1)+'" y="'+(baseY-hgt).toFixed(1)+'" width="'+w+'" height="'+hgt.toFixed(1)+'" '
      +'data-name="'+esc(name)+'" data-total="'+NUM(total)+'" data-pct="'+pctTxt(pct)+'"></rect>';
  }
  for(var i=0;i<N;i++){
    var cx=padL+slotW*i+slotW/2;
    if(hasCmp){
      var bw=16, g=8, x1=cx-bw-g/2, x2=cx+g/2;
      var pP=base[i].v/t0, pC=cs[i].v/tc0, h1=hp(pP), h2=hp(pC);
      bars+=bar_('pad-ff-b1',x1,h1,bw,baseName,base[i].v,pP);
      bars+=bar_('pad-ff-b2',x2,h2,bw,(cmp.name||'Comparado'),cs[i].v,pC);
      // uma métrica só: as duas porcentagens (produto amarelo / comparado azul)
      var ytop=(baseY-Math.max(h1,h2)-6).toFixed(1);
      labels+='<text class="pad-ff-num" x="'+cx.toFixed(1)+'" y="'+ytop+'" text-anchor="middle">'
        +'<tspan fill="#fff200">'+pctTxt(pP)+'</tspan><tspan fill="#8a8a8a"> / </tspan><tspan fill="#9fb0ff">'+pctTxt(pC)+'</tspan></text>';
    } else {
      var bw0=22, pct=base[i].v/t0, hh=hp(pct);
      bars+=bar_('pad-ff-b1',cx-bw0/2,hh,bw0,baseName,base[i].v,pct);
      labels+='<text class="pad-ff-num" x="'+cx.toFixed(1)+'" y="'+(baseY-hh-13).toFixed(1)+'" text-anchor="middle">'+NUM(base[i].v)+'</text>';
      labels+='<text class="pad-ff-pct" x="'+cx.toFixed(1)+'" y="'+(baseY-hh-4).toFixed(1)+'" text-anchor="middle">'+pctTxt(pct)+'</text>';
    }
    labels+='<svg class="pad-ff-ico" x="'+(cx-4).toFixed(1)+'" y="'+(baseY+8)+'" width="8" height="8" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'+(FUN_ICO[base[i].ic]||'')+'</svg>';
    labels+='<text class="pad-ff-lab" x="'+cx.toFixed(1)+'" y="'+(baseY+23)+'" text-anchor="middle">'+esc(base[i].n)+'</text>';
  }
  var cmpLeg='';
  if(hasCmp){ cmpLeg='<div class="pad-ff-leg"><span class="pad-ff-lg"><i class="d base"></i>Este produto</span>'
      +'<span class="pad-ff-lg"><i class="d cmp"></i>'+esc(cmp.name||'Comparado')+'</span></div>'; }
  var svg='<svg class="pad-ff-svg" viewBox="0 0 '+W+' '+H+'" preserveAspectRatio="xMidYMid meet">'
    +grid+'<line class="pad-ff-axis" x1="'+padL+'" y1="'+baseY+'" x2="'+(W-padR)+'" y2="'+baseY+'"/>'
    +bars+labels+'</svg>';
  return '<div class="pad-ff-wrap">'+cmpLeg+svg+'<div class="pad-ff-tip" hidden></div></div>';
}
function funnelCompareCtrl(){
  return '<div class="pad-cmp"><span class="pad-cmp-lbl">Comparar:</span>'
    +'<div class="pad-cmp-box" id="pad-cmp-box">'
    +'<input type="text" id="pad-cmp-inp" class="pad-cmp-inp" placeholder="Buscar produto…" autocomplete="off">'
    +'<span class="pad-cmp-caret" id="pad-cmp-caret" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg></span>'
    +'<button type="button" id="pad-cmp-clear" class="pad-cmp-clear" title="Limpar" hidden>×</button>'
    +'<div class="pad-cmp-list" id="pad-cmp-list" hidden></div>'
    +'</div></div>';
}
function srcPanel(origem){
  var COL={Instagram:"#e1306c",Facebook:"#1877f2",Google:"#ea4335",TikTok:"#00f2ea",Direto:"#8a8a8a",Email:"#f5a623",Whatsapp:"#25d366","Orgânico":"#48f91e"};
  var ORDER=["Instagram","Facebook","Google","TikTok","Direto","Email","Whatsapp","Orgânico"];
  var byName={}; (origem||[]).forEach(function(o){byName[o.canal]=o;});
  var total=(origem||[]).reduce(function(s,o){return s+Number(o.pedidos||0);},0);
  if(!total){
    return '<div class="pad-panel"><div class="pad-panel-head"><h2>'+ic("route")+'Origem das vendas</h2><span class="pad-tag">sem dados</span></div>'
      +'<div class="pad-panel-body"><p class="pad-note">Sem atribuição de origem (GA4) para os pedidos deste período.</p></div></div>';
  }
  var maxPct=Math.max.apply(null,(origem||[]).map(function(o){return Number(o.pct||0);}))||1;
  var cells=ORDER.filter(function(n){return byName[n];}).map(function(n){
    var o=byName[n], col=COL[n]||"#8a8a8a", pct=Number(o.pct||0);
    return '<div class="pad-src"><div class="pad-src-top">'
      +'<span class="pad-src-name"><span class="pad-src-dot" style="background:'+col+'"></span>'+n+'</span>'
      +'<span class="pad-src-pct" data-to="'+pct+'" data-fmt="pct">0%</span></div>'
      +'<div class="pad-src-bar"><div class="pad-src-fill" style="background:'+col+'" data-w="'+((pct/maxPct)*100).toFixed(0)+'"></div></div>'
      +'<span class="pad-src-sub">'+NUM(o.pedidos)+' pedido'+(o.pedidos==1?"":"s")+'</span></div>';
  }).join("");
  return '<div class="pad-panel"><div class="pad-panel-head"><h2>'+ic("route")+'Origem das vendas</h2>'
    +'<span class="pad-tag">'+NUM(total)+' pedidos</span></div>'
    +'<div class="pad-panel-body"><div class="pad-src-grid">'+cells+'</div></div></div>';
}
function variantsTable(vx, fallback){
  var rows;
  if(vx&&vx.length){
    var maxRec=Math.max.apply(null,vx.map(function(v){return Number(v.receita||0);}))||1;
    rows=vx.map(function(v){
      var conv=v.share; // proxy: participação nas vendas do produto
      return '<tr><td>'+esc(v.tamanho||v.cor||"—")+'</td>'
        +'<td class="r" data-to="'+(v.unidades||0)+'" data-fmt="num">0</td>'
        +'<td class="r" data-to="'+(v.receita||0)+'" data-fmt="brl">'+BRL(0)+'</td>'
        +'<td class="r acc" data-to="'+conv+'" data-fmt="pct">0%</td>'
        +'<td class="r '+(v.cancelados>0?"bad":"")+'">'+NUM(v.cancelados||0)+'</td>'
        +'<td class="r '+(v.devolucoes>0?"bad":"")+'">'+NUM(v.devolucoes||0)+'</td></tr>';
    }).join("");
  } else if(fallback&&fallback.length){
    rows=fallback.map(function(v){
      return '<tr><td>'+esc(v.variant_title||v.tamanho||"—")+'</td>'
        +'<td class="r" data-to="'+(v.unidades_vendidas||0)+'" data-fmt="num">0</td>'
        +'<td class="r" data-to="'+(v.receita_gerada||0)+'" data-fmt="brl">'+BRL(0)+'</td>'
        +'<td class="r">—</td><td class="r">—</td><td class="r">—</td></tr>';
    }).join("");
  } else {
    return '';
  }
  return '<div class="pad-panel"><div class="pad-panel-head"><h2>'+ic("grid")+'Variantes · desempenho por tamanho</h2>'
    +'<span class="pad-tag">part. = share de vendas</span></div>'
    +'<div class="pad-panel-body" style="padding:0"><table class="pad-tbl">'
    +'<thead><tr><th>Tamanho</th><th class="r">Unidades</th><th class="r">Receita</th><th class="r">Part.</th><th class="r">Cancel.</th><th class="r">Devol.</th></tr></thead>'
    +'<tbody>'+rows+'</tbody></table></div></div>';
}
function timingPanel(t){
  if(!t || !t.buckets){
    return '<div class="pad-panel"><div class="pad-panel-head"><h2>'+ic("clock")+'Tempo até a compra</h2><span class="pad-tag">sem dados</span></div>'
      +'<div class="pad-panel-body"><p class="pad-note">Sem dados do BigQuery Export ainda. Aparece após ativar o export GA4→BigQuery e a próxima sincronização (aba <b>ga4_bq_daily</b>).</p></div></div>';
  }
  var avgH=Number(t.avg_hours||0);
  var avgTxt=avgH<1?(Math.round(avgH*60)+" min"):avgH<48?(avgH.toFixed(1)+"h"):((avgH/24).toFixed(1)+" dias");
  var cells=t.buckets.map(function(b){
    return '<div class="pad-tim"><div class="pad-tim-val" data-to="'+(b.pct||0)+'" data-fmt="pct">0%</div><div class="pad-tim-lbl">'+esc(b.label)+'</div>'
      +'<div class="pad-tim-lbl" style="opacity:.6">'+NUM(b.n||0)+' compras</div></div>';
  }).join("");
  return '<div class="pad-panel"><div class="pad-panel-head"><h2>'+ic("clock")+'Tempo da 1ª visita até a compra</h2>'
    +'<span class="pad-tag">média '+avgTxt+'</span></div>'
    +'<div class="pad-panel-body" style="padding:0"><div class="pad-timing">'+cells+'</div></div></div>';
}
function comparePanel(d){
  var rng=d.range||{};
  // card por métrica: ícone + valor + gauge (escala = mín/máx dos produtos do mesmo tipo com venda, tick na média)
  function cx(key,lbl,ico,val,avg,fmt,higherBetter){
    var f = fmt==="brl"?BRL:fmt==="pct"?PCT:fmt==="sec"?SEC:fmt==="kbrl"?kBRL:NUM;
    var v = Number(val)||0;
    var has = avg!=null && isFinite(avg) && (avg!==0 || !!key); // métricas com faixa dos pares aceitam média 0
    var delta = has ? (avg!==0 ? (v-avg)/Math.abs(avg) : (v>0?1:0)) : null;
    var good = delta==null?null:(higherBetter?delta>=0:delta<=0);
    var dTxt = delta==null?'—':(avg===0 ? (v>0?('+'+NUM(v)+' vs média 0'):'na média') : ((delta>=0?'+':'')+(delta*100).toFixed(0)+'% vs média'));
    var r = key&&rng[key]&&isFinite(rng[key].min)&&isFinite(rng[key].max)&&rng[key].max>rng[key].min ? rng[key] : null;
    // média SEMPRE no centro; a barra diverge do centro, escalada pela faixa dos pares (ou pelo delta)
    var pos;
    if(r&&has){
      var half=Math.max(Math.abs(r.max-avg),Math.abs(avg-r.min))||1;
      pos=Math.max(2,Math.min(98,50+(v-avg)/half*48));
    } else {
      pos=delta==null?50:Math.max(2,Math.min(98,50+delta*48));
    }
    var lo=Math.min(pos,50), wd=Math.abs(pos-50);
    var tone=good===null?'':(good?'pos':'neg');
    return '<div class="pad-cx2" title="'+lbl+': '+f(v)+(has?(' · média '+f(avg)):'')+'">'
      +'<div class="pad-cx2-head"><span class="pad-cx2-ic '+tone+'">'+ic(ico)+'</span><span class="pad-cx2-lbl">'+lbl+'</span>'
      +'<span class="pad-cx2-chip '+(good===null?'na':(good?'up':'down'))+'">'+dTxt+'</span></div>'
      +'<div class="pad-cx2-val" data-to="'+v+'" data-fmt="'+fmt+'">'+f(0)+'</div>'
      +'<div class="pad-cx2-gauge"><span class="cx2-fill '+tone+'" style="left:'+lo.toFixed(1)+'%;width:'+wd.toFixed(1)+'%"></span>'
      +'<span class="cx2-avgtick"></span></div>'
      +'<div class="pad-cx2-foot"><span class="cx2-mid">'+(has?'méd '+f(avg):'sem média')+'</span></div></div>';
  }
  // devoluções + trocas num card só (média = pares do mesmo tipo, fonte página de devoluções)
  var devTot=(Number(d.devol)||0)+(Number(d.trocas)||0);
  var devCard=cx("devol","Devoluções","alert",devTot,d.avgDevol,"num",false)
    .replace(/(<span class="cx2-mid">[^<]*<\/span>)/,
      '$1<span class="cx2-split">'+(Number(d.devol)||0)+' dev · '+(Number(d.trocas)||0)+' trocas</span>');
  var body='<div class="pad-cx2-grid cols4">'
    +cx("receita","Receita","money",d.receita,d.avgReceita,"kbrl",true)
    +cx("lucro","Lucro bruto","chart",d.lucro,d.avgLucro,"kbrl",true)
    +cx("ticket","Ticket","compare",d.ticket,d.avgTicket,"brl",true)
    +cx("unidades","Unidades","grid",d.unidades,d.avgUnidades,"num",true)
    +cx(null,"Conversão","check",d.conversao,d.avgConversao,"pct",true)
    +cx(null,"ATC","cart",d.atc,d.avgAtc,"pct",true)
    +cx(null,"Tempo página","clock",d.tempo,d.avgTempo,"sec",true)
    +devCard
    +'</div>';
  var legTipo=d.tipo?esc(d.tipo)+' · '+(d.nPeers||0)+' produtos':'';
  return '<div class="pad-panel"><div class="pad-panel-head"><h2>'+ic("compare")+'Comparação com a média da loja</h2>'
    +'<span class="pad-cx-leg">'+(legTipo?('<span class="cx-leg-tipo">'+legTipo+'</span>'):'')
    +'<i class="lg up"></i>acima<i class="lg down"></i>abaixo</span></div>'
    +'<div class="pad-panel-body" style="padding:0">'+body+'</div></div>';
}
function generalInsights(d){
  var ga=d.ga||{}, c=d.comportamento||{}, cells=[];
  var topSrc=(d.origem[0]&&d.origem[0].canal)||"—";
  cells.push(gi("Origem principal", topSrc, "route"));
  var visitas = (d.visitasCompra)?("~"+Number(d.visitasCompra).toFixed(1)):"—";
  cells.push(gi("Visitas até comprar", visitas, "eye", "Visualizações da página ÷ nº de pedidos pagos no período."));
  cells.push(gi("Scroll médio", ga.has_ga4?PCT(ga.scroll_pct):"—", "gauge"));
  cells.push(gi("Engajamento", ga.has_ga4?PCT(ga.engagement_rate):"—", "star", "% de sessões engajadas: usuário ficou +10s na página, viu 2+ páginas ou disparou um evento de conversão."));
  var ins='<div class="pad-panel pad-gi-main"><div class="pad-panel-head"><h2>'+ic("info")+'Insights gerais</h2>'
    +'<span class="pad-tag">'+cells.length+' métricas</span></div>'
    +'<div class="pad-panel-body" style="padding:0"><div class="pad-gi-grid cols1">'+cells.join("")+'</div></div></div>';
  var icd=d.insightChart||null;
  // fallback: se o backend não mandou o produto mas há GA4 na página, monta o radar do próprio ga
  // (mesmas fórmulas do _myVals no backend) — evita "Sem dados de comportamento (GA4)" indevido
  if((!icd || !icd.produto) && ga && ga.has_ga4){
    var _vw=(ga.pageviews||ga.item_views||0);
    var prodSynth={
      visitas: d.visitasCompra||0,
      carrinho: _vw?(ga.add_to_cart||0)/_vw:0,
      checkout: _vw?(ga.begin_checkout||0)/_vw:0,
      pedidos:  _vw?(ga.purchase||0)/_vw:0,
      scroll_pct: ga.scroll_pct||0,
      engajamento: ga.engagement_rate||0
    };
    icd={ produto:prodSynth, categoria:(icd&&icd.categoria)||null, tipo:(icd&&icd.tipo)||'Todos os produtos', nPeers:(icd&&icd.nPeers)||0 };
  }
  window._padInsightProduto=(icd&&icd.produto)||null;
  var cmp='<div class="pad-panel pad-ic-panel"><div class="pad-panel-head"><h2>'+ic("compare")+'Comparativo</h2>'
    +insightCmpCtrl(icd&&icd.tipo)
    +'</div><div class="pad-panel-body" style="padding:0"><div id="pad-ic-body">'+insightCompareChart(icd)+'</div></div></div>';
  return '<div class="pad-gi-row">'+ins+cmp+'</div>';
}
/* dropdown do comparativo: Categorias + Produtos (padrão: todos os produtos) */
function insightCmpCtrl(label){
  return '<div class="pad-cmp pad-cmp-ic"><div class="pad-cmp-box" id="pad-ic-box">'
    +'<input type="text" id="pad-ic-inp" class="pad-cmp-inp" placeholder="Buscar categoria ou produto…" value="'+esc(label||'Todos os produtos')+'" autocomplete="off">'
    +'<span class="pad-cmp-caret" id="pad-ic-caret" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg></span>'
    +'<div class="pad-cmp-list" id="pad-ic-list" hidden></div>'
    +'</div></div>';
}
function wireInsightCmp_(wrap){
  var box=wrap.querySelector('#pad-ic-box'); if(!box) return;
  var inp=wrap.querySelector('#pad-ic-inp'), caret=wrap.querySelector('#pad-ic-caret'),
      list=wrap.querySelector('#pad-ic-list'), body=wrap.querySelector('#pad-ic-body');
  if(!list||!body) return;
  var prods=(window._padProducts||[]);
  var cats={}; prods.forEach(function(p){ var t=String(p.product_type||'').trim(); if(t) cats[t]=1; });
  var catList=Object.keys(cats).sort(function(a,b){ return a.localeCompare(b,'pt',{sensitivity:'base'}); });
  function buildList(q){
    q=String(q||'').toLowerCase().trim();
    var h='';
    if(!q || 'todos os produtos'.indexOf(q)>=0) h+='<button type="button" class="pad-cmp-opt allprods" data-scope="all">Todos os produtos</button>';
    var mc=catList.filter(function(t){ return !q || t.toLowerCase().indexOf(q)>=0; });
    if(mc.length){ h+='<div class="pad-cmp-grp">Categorias</div>'
      +mc.map(function(t){ return '<button type="button" class="pad-cmp-opt" data-scope="type:'+esc(t)+'" data-label="'+esc(t)+'">'+esc(t)+'</button>'; }).join(''); }
    var mp=prods.filter(function(p){ return !q || String(p.product_title||'').toLowerCase().indexOf(q)>=0; }).slice(0,60);
    if(mp.length){ h+='<div class="pad-cmp-grp">Produtos</div>'
      +mp.map(function(p){ return '<button type="button" class="pad-cmp-opt" data-scope="product:'+esc(p.product_id)+'" data-label="'+esc(p.product_title||'')+'">'+esc(p.product_title||('Produto '+p.product_id))+'</button>'; }).join(''); }
    list.innerHTML=h||'<div class="pad-cmp-empty">Nada encontrado</div>';
  }
  function setOpen(o){ box.classList.toggle('open',o); list.hidden=!o; }
  function openList(q){ buildList(q); setOpen(true); }
  inp.addEventListener('focus',function(){ inp.select(); openList(''); });
  inp.addEventListener('input',function(){ openList(inp.value); });
  if(caret) caret.addEventListener('click',function(e){ e.stopPropagation(); if(list.hidden){ inp.focus(); } else setOpen(false); });
  list.addEventListener('click',function(e){
    var b=e.target.closest('.pad-cmp-opt'); if(!b) return; e.stopPropagation();
    var scope=b.getAttribute('data-scope'), label=b.getAttribute('data-label')||'Todos os produtos';
    inp.value=label; setOpen(false); body.classList.add('is-loading');
    call({resource:'insight_cmp', id:window._padPid, range:(typeof RANGE!=='undefined'?RANGE:'all'), scope:scope}).then(function(rr){
      body.classList.remove('is-loading');
      body.innerHTML=insightCompareChart({ produto:window._padInsightProduto, categoria:(rr&&rr.categoria)||null, tipo:(rr&&rr.tipo)||label, nPeers:(rr&&rr.nPeers)||0 });
      wireInsightChart(wrap);
    }).catch(function(){ body.classList.remove('is-loading'); });
  });
  document.addEventListener('click',function(e){ if(!box.contains(e.target)) setOpen(false); });
}
/* Gráfico sobreposto: este produto × média da categoria (6 métricas GA4/pedidos).
   Cada métrica tem escala própria (produto e média normalizados ao maior dos dois),
   já que as unidades diferem muito (views em centenas × visitas ~1,5). */
function insightCompareChart(ic){
  if(!ic || !ic.produto) return '<div class="pad-ic-empty">'+ic0("info")+'Sem dados de comportamento (GA4) neste período.</div>';
  var P=ic.produto||{}, C=ic.categoria||{};
  var METR=[
    {k:'visitas',      lbl:'Visitas p/ comprar',short:'Visitas',fmt:'dec',ico:'route',inv:true},
    {k:'carrinho',     lbl:'Carrinho',     short:'Carrinho',fmt:'pct',ico:'cart'},
    {k:'checkout',     lbl:'Checkout',     short:'Checkout',fmt:'pct',ico:'check'},
    {k:'pedidos',      lbl:'Conversão',    short:'Conversão',fmt:'pct',ico:'chart'},
    {k:'scroll_pct',   lbl:'Scroll médio', short:'Scroll',  fmt:'pct',ico:'gauge'},
    {k:'engajamento',  lbl:'Engajamento',  short:'Engaj.',  fmt:'pct',ico:'star'}
  ];
  function fmtv(v,f){ if(v==null) return '—'; v=Number(v)||0; if(f==='pct') return PCT(v); if(f==='dec') return '~'+v.toFixed(1); return NUM(v); }
  // valor usado para o RAIO: métricas "inv" (menor é melhor, ex.: visitas p/ comprar) são invertidas (1/v)
  // → quanto menor o valor real, maior o raio (mais longe do centro). O tooltip mantém o valor real.
  function eff(i,raw){ raw=Number(raw)||0; return METR[i].inv ? (raw>0?1/raw:0) : raw; }
  var hasCat = !!ic.categoria;
  // ----- RADAR (hexágono, 6 eixos; produto e média sobrepostos) -----
  var N=METR.length, cx=150, cy=146, R=88, HEAD=1.4;
  function pt(i,r){ var a=(-90 + i*(360/N))*Math.PI/180; return [cx+R*r*Math.cos(a), cy+R*r*Math.sin(a)]; }
  // anéis do grid
  var rings=[0.25,0.5,0.75,1].map(function(rr){
    var pts=[]; for(var i=0;i<N;i++){ var p=pt(i,rr); pts.push(p[0].toFixed(1)+','+p[1].toFixed(1)); }
    return '<polygon class="pad-rad-ring'+(rr===1?' out':'')+'" points="'+pts.join(' ')+'"/>';
  }).join('');
  // raios + rótulos (ícone acima do texto)
  var spokes='', labels='';
  var RICO={eye:ICO.eye,cart:ICO.cart,check:ICO.check,list:ICO.list,gauge:ICO.gauge,route:ICO.route,chart:ICO.chart,star:ICO.star};
  for(var i=0;i<N;i++){
    var e=pt(i,1), lp=pt(i,1.32);
    spokes+='<line class="pad-rad-spoke" x1="'+cx+'" y1="'+cy+'" x2="'+e[0].toFixed(1)+'" y2="'+e[1].toFixed(1)+'"/>';
    labels+='<svg class="pad-rad-ico" x="'+(lp[0]-7).toFixed(1)+'" y="'+(lp[1]-21).toFixed(1)+'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">'+(RICO[METR[i].ico]||'')+'</svg>';
    labels+='<text class="pad-rad-lbl" x="'+lp[0].toFixed(1)+'" y="'+(lp[1]+9).toFixed(1)+'" text-anchor="middle">'+esc(METR[i].short)+'</text>';
  }
  // polígonos (cada eixo normalizado ao maior dos dois valores)
  function poly(which){
    var pts=[]; for(var i=0;i<N;i++){ var pe=eff(i,P[METR[i].k]), ce=eff(i,C[METR[i].k]), mx=Math.max(pe,ce,1e-6)*HEAD;
      var val=(which==='prod'?pe:ce), r=Math.max(0,Math.min(1,val/mx)); var p=pt(i,r); pts.push(p[0].toFixed(1)+','+p[1].toFixed(1)); }
    return pts.join(' ');
  }
  var catPoly = hasCat?'<polygon class="pad-rad-cat" points="'+poly('cat')+'"/>':'';
  var prodPoly='<polygon class="pad-rad-prod" points="'+poly('prod')+'"/>';
  // fatias de hover: cada eixo vira um setor (±30°) cobrindo todo o raio → hover ativo na fatia inteira
  var Rhit=R*1.18, hits='';
  for(var i=0;i<N;i++){
    var pv=Number(P[METR[i].k]||0), cv=Number(C[METR[i].k]||0);
    var a0=(-90 + i*(360/N) - 30)*Math.PI/180, a1=(-90 + i*(360/N) + 30)*Math.PI/180;
    var x0=cx+Rhit*Math.cos(a0), y0=cy+Rhit*Math.sin(a0);
    var x1=cx+Rhit*Math.cos(a1), y1=cy+Rhit*Math.sin(a1);
    hits+='<path class="pad-rad-hit" d="M'+cx+','+cy+' L'+x0.toFixed(1)+','+y0.toFixed(1)
      +' A'+Rhit.toFixed(1)+','+Rhit.toFixed(1)+' 0 0 1 '+x1.toFixed(1)+','+y1.toFixed(1)+' Z" '
      +'data-lbl="'+esc(METR[i].lbl)+'" data-pv="'+esc(fmtv(pv,METR[i].fmt))+'" data-cv="'+esc(hasCat?fmtv(cv,METR[i].fmt):'—')+'"/>';
  }
  // pontos do produto (visuais)
  var dots='';
  for(var i=0;i<N;i++){
    var pe2=eff(i,P[METR[i].k]), ce2=eff(i,C[METR[i].k]), mx2=Math.max(pe2,ce2,1e-6)*HEAD;
    var pp=pt(i,Math.max(0,Math.min(1,pe2/mx2)));
    dots+='<circle class="pad-rad-dot" cx="'+pp[0].toFixed(1)+'" cy="'+pp[1].toFixed(1)+'" r="2.6"/>';
  }
  var svg='<svg class="pad-rad-svg" viewBox="0 0 300 292" preserveAspectRatio="xMidYMid meet">'
    +rings+spokes+labels+catPoly+prodPoly+dots+hits+'</svg>';
  // rótulo da referência (polígono azul): nome do item escolhido no dropdown.
  // >1 produto = média do grupo; 1 produto = aquele produto específico.
  var refLabel=ic.tipo||'Referência';
  if((ic.nPeers||0)>1) refLabel='Média · '+refLabel;
  return '<div class="pad-ic-chart" data-reflabel="'+esc(refLabel)+'">'
    +'<div class="pad-ic-plot">'+svg+'</div>'
    +'<div class="pad-ic-tip" hidden></div></div>';
}
function ic0(n){ try{ return ic(n); }catch(e){ return ''; } }
/* tooltip do gráfico de insights (estilo Recharts: cartão flutuante com indicadores) */
function wireInsightChart(wrap){
  var chart=wrap.querySelector(".pad-ic-chart"); if(!chart) return;
  var tip=chart.querySelector(".pad-ic-tip"); var plot=chart.querySelector(".pad-ic-plot");
  if(!tip||!plot) return;
  var refLabel=chart.getAttribute("data-reflabel")||"Referência";
  function show(g,e){
    tip.innerHTML='<div class="tip-lbl">'+g.getAttribute("data-lbl")+'</div>'
      +'<div class="tip-row"><span class="tip-dot prod"></span>Este produto<b>'+g.getAttribute("data-pv")+'</b></div>'
      +'<div class="tip-row"><span class="tip-dot cat"></span>'+esc(refLabel)+'<b>'+g.getAttribute("data-cv")+'</b></div>';
    tip.hidden=false;
    var pr=plot.getBoundingClientRect(), gr=g.getBoundingClientRect();
    var x=gr.left-pr.left+gr.width/2, y=gr.top-pr.top;
    tip.style.left=Math.max(4,Math.min(pr.width-tip.offsetWidth-4, x-tip.offsetWidth/2))+"px";
    tip.style.top=Math.max(2,y-tip.offsetHeight-8)+"px";
  }
  plot.querySelectorAll(".pad-rad-hit, .pad-ic-grp").forEach(function(g){
    g.addEventListener("mouseenter",function(e){ g.classList.add("hot"); show(g,e); });
    g.addEventListener("mouseleave",function(){ g.classList.remove("hot"); tip.hidden=true; });
  });
}
function gi(lbl,val,ico,tip){
  var t=tip?' data-tip="'+esc(tip)+'"':'';
  return '<div class="pad-gi'+(tip?' has-tip':'')+'"'+t+'><span class="pad-gi-ic">'+ic(ico||'info')+'</span>'
    +'<div class="pad-gi-tx"><div class="pad-gi-lbl">'+lbl+(tip?' <span class="pad-gi-q">?</span>':'')+'</div><div class="pad-gi-val">'+esc(val)+'</div></div></div>';
}
function devolTotal(vx){ return (vx||[]).reduce(function(s,v){return s+Number(v.devolucoes||0);},0); }
function cancelTotal(vx){ return (vx||[]).reduce(function(s,v){return s+Number(v.cancelados||0);},0); }

/* INSIGHTS → botão flutuante + drawer. Cada item = negrito (métrica) + regular (leitura). */
function aiPanel(d){
  var ga=d.ga||{}, sa=d.storeAvg||{}, f=d.funil||{}, C=[];
  function add(cat,score,tone,ico,lead,rest){ if(score>0) C.push({cat:cat,score:score,tone:tone,ico:ico,lead:lead,rest:rest}); }
  function relD(v,a){ return (a&&isFinite(a))?(v-a)/Math.abs(a):0; }
  function clamp(x,lo,hi){ return Math.max(lo,Math.min(hi,x)); }
  var views=Number(ga.pageviews||ga.item_views||0);
  var conv=Number(ga.conversao||0);

  // ── VENDAS ──
  if(d.receita>0 && d.rankReceita<=3) add("vendas",78+(3-d.rankReceita)*6,"acc","trophy","#"+d.rankReceita+" em receita na loja",d.rankReceita===1?"top seller do catálogo.":"um dos carros-chefe do catálogo.");
  if(d.participacao>=0.08) add("vendas",clamp(34+d.participacao*160,0,80),"acc","star",PCT(d.participacao)+" do faturamento","peso relevante da loja concentrado neste produto.");
  var rRec=relD(d.receita,d.avgRecLoja);
  if(rRec>0.6 && d.receita>0) add("vendas",clamp(28+rRec*16,0,70),"pos","chart","Receita "+(1+rRec).toFixed(1)+"× a média dos produtos","vendas bem acima do catálogo.");

  // ── RENTABILIDADE (relativo à média — margem é bruta) ──
  var mDelta=d.margem-d.avgMargemLoja;
  if(d.avgMargemLoja>0 && mDelta>0.04) add("rent",clamp(40+mDelta*260,0,88),"pos","money","Margem "+(mDelta*100).toFixed(0)+" p.p. acima da média","mais rentável que o produto médio — priorize em campanhas.");
  else if(d.avgMargemLoja>0 && mDelta<-0.04) add("rent",clamp(40+Math.abs(mDelta)*260,0,88),"warn","money","Margem "+Math.abs(mDelta*100).toFixed(0)+" p.p. abaixo da média","menos rentável que a média da loja — revise custo ou preço.");
  if(d.receita>d.avgRecLoja*1.3 && d.avgMargemLoja>0 && d.margem<d.avgMargemLoja*0.85) add("rent",74,"warn","alert","Vende muito, lucra pouco","receita alta com margem abaixo da média — foco em reduzir custo.");
  if(d.avgTicketLoja>0 && d.ticket>d.avgTicketLoja*1.3 && ga.has_ga4 && sa.conversao && conv>0 && conv<sa.conversao*0.85) add("rent",60,"acc","money","Ticket "+(d.ticket/d.avgTicketLoja).toFixed(1)+"× a média compensa a conversão","ticket alto sustenta o faturamento apesar da conversão baixa.");

  // ── CONVERSÃO ──
  if(ga.has_ga4 && sa.conversao){
    var cRel=relD(conv,sa.conversao);
    if(cRel>0.25) add("conv",clamp(38+cRel*50,0,80),"pos","check","Conversão "+PCT(conv)+" (+"+Math.round(cRel*100)+"% vs média)","página convertendo acima do catálogo.");
    else if(cRel<-0.3 && views>150) add("conv",clamp(40+Math.abs(cRel)*50,0,82),"warn","filter","Conversão "+PCT(conv)+" ("+Math.round(cRel*100)+"% vs média)","abaixo da média da loja — há espaço na página.");
  }
  if(ga.has_ga4 && sa.pageviews && views>sa.pageviews*1.5 && sa.conversao && conv>0 && conv<sa.conversao*0.6)
    add("corr",90,"warn","filter","Tráfego alto, conversão baixa","muita visita e pouca venda — o gargalo está na página, não na aquisição.");

  // ── COMPORTAMENTO ──
  if(ga.has_ga4 && sa.tempo_medio_seg){
    var tRel=relD(ga.tempo_medio_seg,sa.tempo_medio_seg);
    if(tRel<-0.4) add("comp",clamp(35+Math.abs(tRel)*45,0,72),"warn","clock","Tempo na página baixo ("+SEC(ga.tempo_medio_seg)+")","usuários saem rápido — reforce o topo da página.");
  }
  if(ga.has_ga4 && sa.scroll_pct && ga.scroll_pct<sa.scroll_pct*0.7) add("comp",55,"warn","eye","Scroll médio baixo ("+PCT(ga.scroll_pct)+")","poucos chegam à descrição e às avaliações.");
  if(ga.has_ga4 && sa.bounce_rate && ga.bounce_rate>sa.bounce_rate*1.3) add("comp",58,"warn","alert","Alta taxa de saída ("+PCT(ga.bounce_rate)+")","muitos saem sem interagir.");
  if(ga.has_ga4 && sa.tempo_medio_seg && sa.conversao && ga.tempo_medio_seg>sa.tempo_medio_seg*1.3 && conv>0 && conv<sa.conversao*0.8)
    add("corr",80,"warn","eye","Prende atenção, mas converte pouco","interesse alto sem convencimento — teste CTA e oferta.");

  // ── FUNIL (maior perda entre etapas) ──
  (function(){
    var st=[{n:"visualização",v:Number(f.view_item||f.pagina||0)},{n:"carrinho",v:Number(f.add_to_cart||0)},{n:"checkout",v:Number(f.begin_checkout||0)},{n:"pagamento",v:Number(f.compra||0)}];
    var worst=null;
    for(var i=1;i<st.length;i++){ if(st[i-1].v>0){ var drop=1-st[i].v/st[i-1].v; if(!worst||drop>worst.drop) worst={from:st[i-1].n,to:st[i].n,drop:drop}; } }
    if(worst && worst.drop>0.6 && st[0].v>50) add("funil",clamp(45+worst.drop*40,0,86),"warn","filter","Maior perda: "+worst.from+" → "+worst.to,"queda de "+Math.round(worst.drop*100)+"% nessa etapa — gargalo do funil.");
  })();

  // ── VARIANTES ──
  if(d.variantes&&d.variantes.length){
    var tv=d.variantes[0], tvShare=Number(tv.share||0);
    if(tvShare>=0.55) add("var",clamp(45+tvShare*40,0,85),"acc","grid","Receita concentrada no "+esc(tv.tamanho||tv.variant_title)+" ("+PCT(tvShare)+")","dependência de um tamanho — oportunidade de ampliar a oferta.");
    else if(tvShare>=0.38) add("var",clamp(30+tvShare*40,0,66),"acc","grid","Tamanho "+esc(tv.tamanho||tv.variant_title)+" domina ("+PCT(tvShare)+")","priorize esse tamanho em estoque e campanha.");
    var totDevol=0,maxDev=null;
    d.variantes.forEach(function(v){ totDevol+=Number(v.devolucoes||0); if(!maxDev||Number(v.devolucoes||0)>Number(maxDev.devolucoes||0)) maxDev=v; });
    if(maxDev && Number(maxDev.devolucoes||0)>=2 && totDevol>0 && Number(maxDev.devolucoes)/totDevol>0.6) add("var",52,"neg","alert","Devoluções concentradas no "+esc(maxDev.tamanho||maxDev.variant_title),"revise a grade/medidas desse tamanho.");
  }

  // ── TEMPO ──
  if(d.orders>0){
    var wePer=d.weekendSales/2, wdPer=d.weekdayS/5;
    if(wePer>wdPer*1.4 && d.weekendSales>=3) add("tempo",46,"acc","calendar","Vende mais em finais de semana","concentre mídia e ofertas sáb–dom.");
    else if(wdPer>wePer*1.6 && d.weekdayS>=5) add("tempo",40,"acc","calendar","Vende mais em dias úteis","reduza budget no fim de semana.");
    if(d.peakHour>=19) add("tempo",42,"acc","clock","Pico de vendas às "+d.peakHour+"h","melhor janela para anúncios.");
    else if(d.bestWdName) add("tempo",30,"acc","calendar","Melhor dia: "+d.bestWdName,"reforce campanhas nesse dia.");
  }

  // ── ORIGEM ──
  if(d.origem&&d.origem.length){ var ts=d.origem[0]; if(ts&&ts.pct>=0.4) add("origem",clamp(30+ts.pct*45,0,72),"acc","route",PCT(ts.pct)+" das vendas via "+esc(ts.canal),"canal dominante — a proteger e diversificar."); }

  // ── REGIÃO ──
  if(d.comportamento&&d.comportamento.cidade) add("regiao",34,"acc","route","Concentra em "+esc(d.comportamento.cidade)+(d.comportamento.estado?"/"+esc(d.comportamento.estado):""),"considere frete e segmentação regional.");

  // ── TIMING (BigQuery) ──
  if(d.timing&&d.timing.buckets){
    var bi=d.timing.buckets[0]||{}, mais=d.timing.buckets[3]||{};
    if(Number(bi.pct)>=0.4) add("timing",clamp(30+Number(bi.pct)*45,0,70),"acc","bolt",PCT(bi.pct)+" compram por impulso","na 1ª visita — reforce a oferta acima da dobra.");
    else if(Number(mais.pct)>=0.4) add("timing",clamp(30+Number(mais.pct)*45,0,70),"warn","clock",PCT(mais.pct)+" compram após 3+ dias","invista em remarketing e recuperação.");
  }

  // ── seleção: só o que salta aos olhos (máx 2 por categoria, top 7, score mínimo) ──
  C.sort(function(a,b){return b.score-a.score;});
  var perCat={}, out=[];
  for(var k=0;k<C.length && out.length<7;k++){ var cat=C[k].cat; if(C[k].score<28) continue; perCat[cat]=(perCat[cat]||0)+1; if(perCat[cat]>2) continue; out.push(C[k]); }

  var body;
  if(!out.length){
    body='<div class="pad-aid-empty">Nada salta aos olhos neste período — o produto está dentro da média da loja. Amplie a janela ou aguarde a próxima sincronização do GA4.</div>';
  } else {
    body=out.map(function(x){
      return '<div class="pad-aid-item"><span class="pad-aid-ico '+x.tone+'">'+ic(x.ico)+'</span>'
        +'<span class="pad-aid-txt"><b>'+x.lead+'</b>: '+x.rest+'</span></div>';
    }).join("");
  }
  var n=out.length;
  var fab='<button id="pad-ai-fab" type="button"><span class="pad-fab-dot"></span>Insights'+(n?' · '+n:'')+'</button>';
  var drawer='<div id="pad-ai-drawer">'
    +'<div class="pad-aid-head"><h3>'+ic("bulb")+'Insights</h3>'
    +'<button class="pad-aid-close" type="button" aria-label="Fechar"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div>'
    +'<div class="pad-aid-body">'+body+'</div></div>';
  return fab+drawer;
}

/* imagem grande do CDN */
function bigImg(u){ u=String(u||""); if(!u)return""; return /[?&]width=/.test(u)? u.replace(/([?&])width=\d+/,"$1width=600") : u+(u.indexOf("?")>=0?"&":"?")+"width=600"; }

/* embaralha os dígitos até assentar no valor (recálculo por data / início) */
function scrambleVal(el){
  var to=Number(el.getAttribute("data-to"))||0, fmt=el.getAttribute("data-fmt")||"num";
  var f=fmt==="brl"?BRL:fmt==="pct"?PCT:fmt==="sec"?SEC:fmt==="kbrl"?kBRL:NUM;
  var finalText=f(to), frames=16, frame=0, DIG="0123456789";
  if(el._t) cancelAnimationFrame(el._t);
  function tick(){
    var prog=frame/frames, out="";
    for(var i=0;i<finalText.length;i++){ var c=finalText[i]; if(!/[0-9]/.test(c)){out+=c;continue;} out+= (prog>=(i+1)/finalText.length)? c : DIG[Math.floor(Math.random()*10)]; }
    el.textContent=out;
    if(frame++>=frames){ el.textContent=finalText; el._t=null; return; }
    el._t=requestAnimationFrame(tick);
  }
  el._t=requestAnimationFrame(tick);
}

function kpi(lbl,val,fmt,cls){
  return '<div class="pad-kpi"><span class="pad-kpi-lbl">'+lbl+'</span>'
    +'<span class="pad-kpi-val '+(cls||"")+'" data-to="'+val+'" data-fmt="'+fmt+'">'+(fmt==="brl"?BRL(0):fmt==="pct"?PCT(0):"0")+'</span></div>';
}
function stat(lbl,disp,cls,raw,fmt,icon){
  var attr = (disp==="—"||!fmt) ? "" : ' data-to="'+raw+'" data-fmt="'+fmt+'"';
  return '<div class="pad-stat">'
    +'<span class="pad-stat-lbl">'+(icon?'<span class="pad-stat-ic">'+ic(icon)+'</span>':'')+lbl+'</span>'
    +'<span class="pad-stat-val '+(cls||"")+'"'+attr+'>'+disp+'</span></div>';
}
function row2(lbl,val,cls){
  return '<div class="pad-row"><span class="pad-row-lbl">'+lbl+'</span><span class="pad-row-val'+(cls?" "+cls:"")+'">'+val+'</span></div>';
}
function panelG(title,icon,body,grow){
  return '<div class="pad-panel'+(grow?" grow":"")+'">'
    +'<div class="pad-panel-head"><h2>'+(icon?ic(icon):"")+esc(title)+'</h2></div>'
    +'<div class="pad-panel-body">'+body+'</div></div>';
}
function predRing(score,label,color){
  return '<div class="pad-pred"><div class="pad-pred-ring">'+scoreRing(score,52,color)
    +'<div class="pad-pred-ring-val">'+score+'</div></div><div class="pad-pred-lbl">'+label+'</div></div>';
}
})();